import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react'
import style from './Community.module.css'
import floatingStyles from './CommunityFloatingIcons.module.css'
import ProfileImage from '../../assests/Profile-PNG-File.png'
import { BsChatDots, BsPersonPlus } from 'react-icons/bs';
import { MdCalendarMonth, MdPerson } from 'react-icons/md';
import { SiBookstack } from 'react-icons/si';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../Loder/Loader'
import { IoSend, IoTimeOutline, IoMailUnreadOutline, IoChevronForward, IoChevronBack } from "react-icons/io5";
import { AiOutlineClose } from "react-icons/ai";
import { AiOutlinePlus } from "react-icons/ai";
import { AiOutlineSearch } from "react-icons/ai";
import { doc } from "firebase/firestore";
import { db } from '../Firebase';
import {
  query,
  orderBy,
  onSnapshot,
  collection,
} from "firebase/firestore";
import { baseurl } from '../Url'
import Whiteboard from '../WhiteBoard/WhiteBoard';
import { BiClipboard } from "react-icons/bi";
import { SiGooglemeet } from "react-icons/si";
import { generateMeetingUrl } from '../GoogleMeet';
import { useSelector, useDispatch } from 'react-redux';
import { UserProfile } from "../../actions/user";
import { useCommunitySearch } from '../Context/CommunitySearchContext';
import Switch from 'react-switch';
import { useOutletContext } from 'react-router-dom';
import { MdMoreVert } from 'react-icons/md';

const Community = () => {
  const REFERRAL_SUBTAB_STORAGE_KEY = "communityReferralSubTab";
  const COMMUNITY_SECTION_STORAGE_KEY = "communityActiveSection";
  const COMMUNITY_SECTIONS = ["Members", "Connections", "Opportunities", "Events", "Referrals"];
  const savedCommunitySection = localStorage.getItem(COMMUNITY_SECTION_STORAGE_KEY);
  const initialCommunitySection = COMMUNITY_SECTIONS.includes(savedCommunitySection) ? savedCommunitySection : null;
  const key = JSON.parse(localStorage.getItem("access-token"));
  const USERID = localStorage.getItem("USERID");
  const OrgID = localStorage.getItem("ORGID");
  const ClubID = localStorage.getItem("ClubID")
  const mentor = localStorage.getItem("mentor")
  const UserName = localStorage.getItem("username")
  const navigate = useNavigate()
  const location = useLocation();
  const rawRole = (localStorage.getItem("role") || localStorage.getItem("authPortal") || "").toLowerCase();
  const isPartnerUser = rawRole === "partner" || rawRole === "patner";
  const [details, setDetails] = useState([]);
  const { onMenuToggle, sidebarOpen } = useOutletContext() || {};
  const [lodaing, setLoading] = useState(true)
  const [popup, setPopup] = useState(false)
  const [message, setMessage] = useState("")
  const [recever, setRecever] = useState("")
  const [receverid, setReceverID] = useState("")
  const [firestoreid, setFirestoreID] = useState("")
  const [mongoid, setMongoId] = useState("")
  const [chat, setChat] = useState([])
  const [chatLoader, setChatLoader] = useState(false)
  const [searcheditem, setSearchedItem] = useState([])
  const [invite, setInvite] = useState(false)
  const { searchTerm: allsearch, setSearchTerm } = useCommunitySearch()
  const [inviteEmail, setInviteEmail] = useState("")
  const [activeFilter, setActiveFilter] = useState(initialCommunitySection || "All")
  const [activeSubMenu, setActiveSubMenu] = useState("All")
  const [activeMemberSubMenu, setActiveMemberSubMenu] = useState(initialCommunitySection || "Members")
  const [activeOverviewTab, setActiveOverviewTab] = useState(initialCommunitySection || "Members")
  const [memberTypeFilter, setMemberTypeFilter] = useState("All") // All | Candidates | Mentors
  const [memberTypeDropdownOpen, setMemberTypeDropdownOpen] = useState(false)
  const [memberSearchTerm, setMemberSearchTerm] = useState("")
  const [membersPage, setMembersPage] = useState(1)
  const [membersTotalPages, setMembersTotalPages] = useState(0)
  const [opportunitiesOverviewPage, setOpportunitiesOverviewPage] = useState(1)
  const [opportunitiesTabPage, setOpportunitiesTabPage] = useState(1)
  const [opportunitiesOverviewVisibleInPage, setOpportunitiesOverviewVisibleInPage] = useState(5)
  const [opportunitiesTabVisibleInPage, setOpportunitiesTabVisibleInPage] = useState(5)
  const [eventsOverviewPage, setEventsOverviewPage] = useState(1)
  const [eventsTabPage, setEventsTabPage] = useState(1)
  const [membersLoadingMore, setMembersLoadingMore] = useState(false)
  const [generateLink, setGenerateLink] = useState("")
  const [trigger, setTrigger] = useState(0);
  const [buttonState, setButtonstate] = useState({})
  const [whiteBoradShow, setWhiteBoardShow] = useState(false)
  const [whiteBoradIconShow, setWhiteBoardIconShow] = useState(true)
  const [meetingButton, setMeetingButton] = useState(true)
  const [userEmail, setUserEmail] = useState("")
  const [userEmailError, setUserEmailError] = useState("");
  const [opportunities, setOpportunities] = useState([])
  const [opportunitiesLoading, setOpportunitiesLoading] = useState(false)
  const [communityList, setCommunityList] = useState([])
  const [communityListLoading, setCommunityListLoading] = useState(false)
  const [events, setEvents] = useState([])
  const [eventsLoading, setEventsLoading] = useState(false)
  const [searchText, setSearchText] = useState("");
  const [eventSearchTerm, setEventSearchTerm] = useState("");
  const [opportunitySearchTerm, setOpportunitySearchTerm] = useState("");
  const [connectionSearchTerm, setConnectionSearchTerm] = useState("");
  const [connectionsList, setConnectionsList] = useState([]);
  const [connectionsLoading, setConnectionsLoading] = useState(false);
  const [requestCount, setRequestCount] = useState(0);
  const [sentRequestCount, setSentRequestCount] = useState(0);
  const [incomingRequests, setIncomingRequests] = useState([]);
  const [referralSubTab, setReferralSubTab] = useState(() => {
    const savedReferralSubTab = localStorage.getItem(REFERRAL_SUBTAB_STORAGE_KEY);
    if (!savedReferralSubTab) return "Received";
    return savedReferralSubTab.toLowerCase() === "given" ? "Given" : "Received";
  });
  const [referralSearchTerm, setReferralSearchTerm] = useState("");
  const [receivedReferrals, setReceivedReferrals] = useState([]);
  const [givenReferrals, setGivenReferrals] = useState([]);
  const [referralLoading, setReferralLoading] = useState(false);
  const [sectionExpanded, setSectionExpanded] = useState({ members: false, events: false, connections: false, opportunities: false, membersTab: false, connectionsTab: false, eventsTab: false, opportunitiesTab: false });
  const [showNoDetailsPopup, setShowNoDetailsPopup] = useState(false);
  const filterTabsRef = useRef(null);
  const iconRef = useRef(null);
  const iconDragRef = useRef({ dragging: false, offsetX: 0, offsetY: 0 });
  const [iconPosition, setIconPosition] = useState(null);
  const meetingIconRef = useRef(null);
  const meetingIconDragRef = useRef({ dragging: false, offsetX: 0, offsetY: 0 });
  const [meetingIconPosition, setMeetingIconPosition] = useState(null);
  const memberTypeOptions = ["All", "Candidates", "Mentors", "Employer"];
  const whiteboardRef = useRef(null);
  const whiteboardDragRef = useRef({ dragging: false, offsetX: 0, offsetY: 0 });
  const [whiteboardPosition, setWhiteboardPosition] = useState(null);
  const [isMobileFloatingView, setIsMobileFloatingView] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth <= 1024 : false
  );
  const mobileFloatingModeRef = useRef(typeof window !== "undefined" ? window.innerWidth <= 1024 : false);
  const lastFloatingViewportWidthRef = useRef(typeof window !== "undefined" ? window.innerWidth : 0);
  const lastFloatingViewportHeightRef = useRef(typeof window !== "undefined" ? window.innerHeight : 0);
  const [isMentor, setIsMentor] = useState(false);
  const isMembersSearchLoading =
    (communityListLoading || membersLoadingMore) && String(memberSearchTerm || "").trim().length > 0;
  useEffect(() => {
    if (isPartnerUser) {
      navigate("/dashboard", { replace: true, state: { from: location.pathname } });
    }
  }, [isPartnerUser, navigate, location.pathname]);

  if (isPartnerUser) {
    return null;
  }
  const getRoleLabel = useCallback((role) => {
    if (!role) return "";
    const r = String(role);
    return r === "Intern" ? "Candidate" : r;
  }, []);
  const getProfileSrc = useCallback((rawSrc) => {
    const isValidImageSrc = (src) => {
      const s = String(src ?? "").trim().replace(/^['"]|['"]$/g, "");
      if (!s) return false;
      const lowered = s.toLowerCase();
      if (lowered === "null" || lowered === "undefined" || lowered === "n/a" || lowered === "-") {
        return false;
      }
      const isWebUrl = /^https?:\/\//i.test(s);
      const isDataUrl = /^data:image\//i.test(s);
      const isBlobUrl = /^blob:/i.test(s);
      const isRootRelative = s.startsWith("/");
      const isRelativePath = !isWebUrl && !isDataUrl && !isBlobUrl && !isRootRelative && /[\\/]/.test(s);
      const looksLikeImageFile = /\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$/i.test(s);
      return isWebUrl || isDataUrl || isBlobUrl || isRootRelative || isRelativePath || looksLikeImageFile;
    };

    // Some records store profile as object/json (e.g. { image: "..." }).
    let candidate = rawSrc;
    if (candidate && typeof candidate === "object") {
      candidate =
        candidate.image ||
        candidate.profile_image ||
        candidate.profile ||
        candidate.url ||
        candidate.avatar ||
        candidate.avatar_url ||
        "";
    } else if (typeof candidate === "string") {
      const trimmed = candidate.trim();
      if ((trimmed.startsWith("{") && trimmed.endsWith("}")) || (trimmed.startsWith("[") && trimmed.endsWith("]"))) {
        try {
          const parsed = JSON.parse(trimmed);
          if (parsed && typeof parsed === "object") {
            candidate =
              parsed.image ||
              parsed.profile_image ||
              parsed.profile ||
              parsed.url ||
              parsed.avatar ||
              parsed.avatar_url ||
              "";
          }
        } catch {
          // keep original string candidate
        }
      }
    }

    if (!isValidImageSrc(candidate)) return ProfileImage;

    const src = String(candidate).trim().replace(/^['"]|['"]$/g, "");
    const isWebUrl = /^https?:\/\//i.test(src);
    const isDataUrl = /^data:image\//i.test(src);
    const isBlobUrl = /^blob:/i.test(src);
    if (isWebUrl || isDataUrl || isBlobUrl) return src;

    if (src.startsWith("/")) return src;

    // Backend sometimes returns relative paths like "uploads/profile/abc.jpg".
    // Convert them to absolute API URLs so images render in Community cards.
    const apiBase = String(baseurl || "").replace(/\/+$/, "");
    if (!apiBase) return `/${src.replace(/^\/+/, "")}`;
    return `${apiBase}/${src.replace(/^\/+/, "")}`;
  }, []);
  const handleProfileImageError = useCallback((e) => {
    if (!e?.currentTarget) return;
    const img = e.currentTarget;
    if (img.dataset?.fallbackApplied === "1") return;
    img.dataset.fallbackApplied = "1";
    img.src = ProfileImage;
  }, []);

  const getPageItems = useCallback((current, total) => {
    const c = Math.max(1, Number(current) || 1);
    const t = Math.max(1, Number(total) || 1);

    // Mobile/tablet: keep pagination compact to avoid wrapping/clipping.
    if (isMobileFloatingView) {
      if (t <= 3) return Array.from({ length: t }, (_, i) => i + 1);
      let start = Math.max(1, c - 1);
      let end = Math.min(t, start + 2);
      start = Math.max(1, end - 2);
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }

    if (t <= 7) return Array.from({ length: t }, (_, i) => i + 1);

    const items = [];
    items.push(1);
    const start = Math.max(2, c - 1);
    const end = Math.min(t - 1, c + 1);
    if (start > 2) items.push("…");
    for (let p = start; p <= end; p++) items.push(p);
    if (end < t - 1) items.push("…");
    items.push(t);
    return items;
  }, [isMobileFloatingView]);
  const isUpcomingEvent = useCallback((event) => {
    const now = new Date();
    const startRaw = event?.event_start_date || event?.start_date;
    const endRaw = event?.event_end_date || event?.end_date;
    const start = startRaw ? new Date(startRaw) : null;
    const end = endRaw ? new Date(endRaw) : null;
    if (!start || Number.isNaN(start.getTime())) return false;
    if (!end || Number.isNaN(end.getTime())) return start >= now;
    return start >= now && end >= now;
  }, []);
  const isActiveOpportunity = useCallback((opportunity) => {
    const rawDate = opportunity?.valid_upto;
    if (!rawDate) return true;
    const validUpto = new Date(rawDate);
    if (Number.isNaN(validUpto.getTime())) return true;
    const now = new Date();
    return validUpto >= now;
  }, []);

  const isAppliedOpportunity = useCallback((opportunity) => {
    if (!opportunity || typeof opportunity !== "object") return false;

    const explicitFlags = [
      opportunity.has_applied,
      opportunity.already_applied,
      opportunity.is_applied,
      opportunity.applied,
      opportunity.user_applied,
      opportunity.applied_status,
      opportunity.application_status,
    ];

    if (explicitFlags.some((v) => v === true || v === 1 || v === "1")) return true;

    const statusText = String(
      opportunity.applied_status ||
      opportunity.application_status ||
      opportunity.status ||
      ""
    ).toLowerCase();

    return statusText.includes("applied") || statusText.includes("already applied");
  }, []);

  const normalizeNewOpportunities = useCallback((items) => {
    return (items || [])
      .filter((opportunity) => !isAppliedOpportunity(opportunity))
      .filter((opportunity) => isActiveOpportunity(opportunity))
      .sort((a, b) => {
        const aDate = new Date(a?.created_date || a?.valid_upto || 0).getTime();
        const bDate = new Date(b?.created_date || b?.valid_upto || 0).getTime();
        return bDate - aDate;
      });
  }, [isActiveOpportunity, isAppliedOpportunity]);

  const isConnectionRequestSent = useCallback((user) => {
    if (!user) return false;

    // Treat only active states as "already requested/connected".
    // Rejected/declined should show "Connect" again.
    const status = (user.connection_status || "").toLowerCase();
    if (status === "pending" || status === "accepted") return true;
    if (status === "rejected" || status === "declined" || status === "decline" || status === "none") {
      return false;
    }

    const v = user.request_send;
    return v === true || v === 1 || v === "1" || v === "true";
  }, []);

  const markUserConnectionPending = useCallback((connectUserId) => {
    const markPending = (user) => {
      if (!user || user._id !== connectUserId) return user;
      return {

        ...user,
        request_send: true,
      };
    };

    setDetails((prev) => Array.isArray(prev) ? prev.map(markPending) : prev);
    setSearchedItem((prev) => Array.isArray(prev) ? prev.map(markPending) : prev);
  }, []);

  const handleUserClick = async (userId, role) => {
    try {
      const res = await fetch(`${baseurl}/candidate/profile/get`, {
        method: "POST",
        body: JSON.stringify({ user_id: userId }),
        headers: { "Content-Type": "application/json" },
      });
      const data = await res.json();
      const hasProfile = data.status === true && data.data && data.data.length > 0;
      if (hasProfile) {
        navigate("/profile/profile-details", { state: { userID: userId, Role: role || "", fromCommunity: true } });
      } else {
        setShowNoDetailsPopup(true);
      }
    } catch (err) {
      console.error("Error checking profile:", err);
      setShowNoDetailsPopup(true);
    }
  };

  const scrollFilterTabs = useCallback((direction) => {
    const el = filterTabsRef.current;
    if (el) el.scrollBy({ left: direction * 100, behavior: 'smooth' });
  }, []);

  const SECTION_LIMIT = 5;
  const MEMBERS_SECTION_LIMIT = 10;
  const OPPORTUNITIES_PAGE_SIZE = 10;
  const EVENTS_PAGE_SIZE = 10;
  const clubIdsArray = useMemo(() => ClubID ? ClubID.split(',') : [], [ClubID]);
  const profileData = useSelector((state) => state.profileData);
  const emptyProfile = useMemo(() => ({}), []);
  const profile = profileData?.profile ?? emptyProfile;

  const dispatch = useDispatch()

  async function userDetails() {
    await fetch(`${baseurl}/user/supportnetwork`, {
      method: "POST",
      body: JSON.stringify({
        org_id: OrgID,
        user_id: USERID,
        club_id: clubIdsArray
      }),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("user/supportnetwork response:", data);
        let members = [];
        if (Array.isArray(data.data)) {
          members = data.data;
        } else if (data.data && Array.isArray(data.data.members)) {
          members = data.data.members;
        } else if (data.data && Array.isArray(data.data.users)) {
          members = data.data.users;
        } else if (data.data?.members && Array.isArray(data.data.members)) {
          members = data.data.members;
        } else if (data.data && typeof data.data === "object") {
          members = data.data.members || data.data.users || Object.values(data.data).find(Array.isArray) || [];
        }
        setDetails(members);
        setLoading(false);
      })
      .catch((err) => {
        console.error("userDetails error:", err);
        setDetails([]);
        setLoading(false);
      });
  }
  async function CheckIsMentor() {
    try {
      const response = await fetch(`${baseurl}/role/get/mentor`, {
        method: "POST",
        body: JSON.stringify({ user_id: USERID ,org_id: OrgID}),
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${key}`,
        },
      });
      const data = await response.json();
      if (data.status === true && data.data=== true) {
        setIsMentor(true);
      } else {
        setIsMentor(false);
      }
    } catch {
      setIsMentor(false);
    }
  }
  useEffect(() => {
    CheckIsMentor();
  }, [USERID])


  async function fetchIncomingRequests() {
    try {
      const response = await fetch(`${baseurl}/user/connection/incoming`, {
        method: "POST",
        body: JSON.stringify({ user_id: USERID }),
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${key}`,
        },
      });
      const data = await response.json();
      if (data.status === true && Array.isArray(data.data)) {
        setIncomingRequests(data.data);
        setRequestCount(data.data.length);
      } else {
        setIncomingRequests([]);
        setRequestCount(0);
      }
    } catch {
      setIncomingRequests([]);
      setRequestCount(0);
    }
  }

  async function fetchOutgoingRequests() {
    try {
      const response = await fetch(`${baseurl}/user/connection/outgoing`, {
        method: "POST",
        body: JSON.stringify({ user_id: USERID }),
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${key}`,
        },
      });
      const data = await response.json();
      if (data.status === true && Array.isArray(data.data)) {
        setSentRequestCount(data.data.length);
      } else {
        setSentRequestCount(0);
      }
    } catch {
      setSentRequestCount(0);
    }
  }

  async function handleRequestAction(connectUserId, action) {
    try {
      const response = await fetch(`${baseurl}/user/connection/update`, {
        method: "POST",
        body: JSON.stringify({
          user_id: USERID,
          connect_user_id: connectUserId,
          action: action === "accept" ? "accepted" : "rejected",
        }),
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${key}`,
        },
      });
      const data = await response.json();
      if (data.status === true) {
        await refreshCommunityAfterAction();
      }
    } catch (error) {
      console.error("Error processing request:", error);
    }
  }

  async function fetchConnections(search = "") {
    setConnectionsLoading(true);
    try {
      const response = await fetch(`${baseurl}/user/connection/list`, {
        method: "POST",
        body: JSON.stringify({
          user_id: USERID,
          search: search || connectionSearchTerm || ""
        }),
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${key}`,
        },
      });
      const data = await response.json();
      if (data.status === true || data.status === "success") {
        setConnectionsList(data.data || []);
      } else {
        setConnectionsList([]);
      }
    } catch (error) {
      console.error("Error fetching connections:", error);
      setConnectionsList([]);
    } finally {
      setConnectionsLoading(false);
    }
  }

  async function fetchOpportunities() {
    setOpportunitiesLoading(true);
    try {
      const memberId = localStorage.getItem('USERID');
      if (!memberId) {
        setOpportunities([]);
        setOpportunitiesLoading(false);
        return;
      }
      const listParams = new URLSearchParams({
        member_id: memberId,
        page: '1',
        limit: '100',
      });
      const response = await fetch(`${baseurl}/vacancies/list?${listParams.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (data.status === 'success') {
        setOpportunities(normalizeNewOpportunities(data.data || []));
      } else {
        setOpportunities([]);
      }
    } catch (error) {
      console.error("Error fetching opportunities:", error);
      setOpportunities([]);
    } finally {
      setOpportunitiesLoading(false);
    }
  }

  async function fetchCommunityList(searchFilters = null, options = {}) {
    setCommunityListLoading(true);
    setEventsLoading(true);
    try {
      const eventId = localStorage.getItem("event_id");
      const nextMembersPage = Number(options?.membersPage || 1);
      const appendMembers = Boolean(options?.appendMembers);
      const explicitSearchTerm =
        typeof options?.searchTerm === "string" ? options.searchTerm : null;
      const isMembersContext =
        activeFilter === "Members" || (activeFilter === "All" && activeOverviewTab === "Members");
      const effectiveSearchTerm =
        explicitSearchTerm !== null
          ? explicitSearchTerm
          : isMembersContext
            ? (memberSearchTerm || "")
            : (searchText || "");

      // Determine search filters based on search term or activeFilter
      let filters = [];
      if (searchFilters) {
        // If filters are passed explicitly, use them
        filters = searchFilters;
      } else if (effectiveSearchTerm) {
        // Detect filter from search term
        const searchLower = effectiveSearchTerm?.toLowerCase().trim() || "";
        if (searchLower === "opportunities" || searchLower === "opportunity" || searchLower.startsWith("opportunit")) {
          filters = ["opportunities"];
        } else if (searchLower === "events" || searchLower === "event" || searchLower.startsWith("event")) {
          filters = ["events"];
        } else if (searchLower === "members" || searchLower === "member" || searchLower.startsWith("member")) {
          filters = ["members"];
        } else {
          // Use activeFilter if search doesn't match filter names
          if (activeFilter === "All") {
            filters = ["members", "events", "opportunities"];
          } else {
            filters = [activeFilter.toLowerCase()];
          }
        }
      } else {
        // No search term, use activeFilter
        if (activeFilter === "All") {
          filters = ["members", "events", "opportunities"];
        } else if (activeFilter === "Connections" || activeFilter === "Referrals") {
          filters = ["members"];
        } else {
          filters = [activeFilter.toLowerCase()];
        }
      }

      await fetch(`${baseurl}/community/list`, {
        method: "POST",
        body: JSON.stringify({
          user_id: USERID,
          org_id: OrgID,
          club_id: clubIdsArray,
          event_id: eventId,
          search: filters, // Pass search filters array to backend
          search_term: effectiveSearchTerm || "", // Ensure members search runs across all pages
          filter_type: memberTypeFilter,
          page: nextMembersPage,
          limit: 10,
        }),
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${key}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          console.log("Community list data:", data);
          if (data.status === true || data.status === 'success') {
            setCommunityList(data.data || {});
            // Extract events from the response
            if (data.data && data.data.events) {
              const nextEvents = (data.data.events || []).filter((event) => isUpcomingEvent(event));
              setEvents(nextEvents);
            } else {
              setEvents([]);
            }
            // Extract opportunities from community response as a fallback only.
            // Do not overwrite a fuller opportunities list with a smaller payload.
            if (data.data && data.data.opportunities) {
              const communityOpportunities = normalizeNewOpportunities(data.data.opportunities || []);
              setOpportunities((prev) => {
                const prevList = Array.isArray(prev) ? prev : [];
                if (prevList.length === 0) return communityOpportunities;
                return prevList.length >= communityOpportunities.length ? prevList : communityOpportunities;
              });
            }
            // Extract members from the response if available
            if (data.data && data.data.members) {
              const members = data.data.members || [];
              const pag = data.data.members_pagination || {};
              const serverPage = Number(pag.page || nextMembersPage || 1);
              const serverTotalPages = Number(pag.total_pages || 0);
              setMembersPage(serverPage);
              setMembersTotalPages(serverTotalPages);
              if (searchText) {
                setSearchedItem(members);
              }
              // Keep members list in sync with API (supports both normal and member search flows).
              setDetails(appendMembers && serverPage > 1 ? [...(details || []), ...members] : members);
            }
          } else {
            setCommunityList({});
            setEvents([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching community list:", error);
          setCommunityList({});
          setEvents([]);
        });
    } catch (error) {
      console.error("Error fetching community list:", error);
      setCommunityList({});
      setEvents([]);
    } finally {
      setCommunityListLoading(false);
      setEventsLoading(false);
      setMembersLoadingMore(false);
    }
  }

  async function roomCreate(rname, rid) {
    await fetch(`${baseurl}/roomcreation`, {
      method: "POST",
      body: JSON.stringify({
        org_id: OrgID,
        sender_id: USERID,
        sender_name: UserName,
        receiver_id: rid,
        receiver_name: rname
      }),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data.data);
        setFirestoreID(data.data[0].firestore_roomid);
        setMongoId(data.data[0].mongoroom_id)
        setTrigger((prevTrigger) => prevTrigger + 1);
        setChatLoader(false)
      });
  }

  async function chatCreate() {
    await fetch(`${baseurl}/chat/create`, {
      method: "POST",
      body: JSON.stringify({
        org_id: OrgID,
        sender_id: USERID,
        sender_name: UserName,
        receiver_id: receverid,
        receiver_name: recever,
        content_type: "text",
        content: message,
        firestore_roomid: firestoreid,
        mongoroom_id: mongoid
      }),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setMessage("")
        setTrigger((prevTrigger) => prevTrigger + 1);
        setChatLoader(false)
      });
  }

  const anyoneSearch = useCallback(async () => {
    if (!allsearch || allsearch.trim() === "") {
      setSearchedItem([]);
      return;
    }

    // Detect filter type from search term or use activeFilter
    const searchLower = allsearch?.toLowerCase().trim() || "";
    let filterType = null;

    if (searchLower === "opportunities" || searchLower === "opportunity" || searchLower.startsWith("opportunit")) {
      filterType = "Opportunities";
    } else if (searchLower === "events" || searchLower === "event" || searchLower.startsWith("event")) {
      filterType = "Events";
    } else if (searchLower === "members" || searchLower === "member" || searchLower.startsWith("member")) {
      filterType = "Members";
    } else {
      // Use activeFilter if search term doesn't match filter names
      filterType = activeFilter !== "All" ? activeFilter : null;
    }

    await fetch(`${baseurl}/supportnetwork/search/anyone/new`, {
      method: "POST",
      body: JSON.stringify({
        org_id: OrgID,
        user_id: USERID,
        search: allsearch,
        club_id: clubIdsArray,
        filter_type: filterType // Pass filter type to backend
      }),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setSearchedItem(data.data || [])
      })
      .catch((error) => {
        console.error("Search error:", error);
        setSearchedItem([]);
      });
  }, [allsearch, OrgID, USERID, clubIdsArray, key, activeFilter]);

  async function requestSend(connectUserId, connectUsername) {
    try {
      const res = await fetch(`${baseurl}/user/connection/send`, {
        method: "POST",
        body: JSON.stringify({
          user_id: USERID,
          username: UserName,
          connect_user_id: connectUserId,
          connect_username: connectUsername,
          org_id: OrgID
        }),
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${key}`,
        },
      });
      const data = await res.json();
      console.log(data);
      if (data.status === true || data.success || data.status_code === 409 || data.description === "Connection already exists") {
        const updatedButtonState = { ...buttonState };
        updatedButtonState[connectUserId] = true;
        setButtonstate(updatedButtonState);
        markUserConnectionPending(connectUserId);
        // Keep user on the same paginated members list; avoid a full list refetch
        // that may be normalized by backend to page 1 after relationship changes.
        await refreshCommunityAfterAction({ skipCommunityList: true, skipUserDetails: true });
      }
    } catch (err) {
      console.error("Connection send error:", err);
    }
  }

  async function inviteGenerate() {
    await fetch(`${baseurl}/generate_invite`, {
      method: "POST",
      body: JSON.stringify({
        name: UserName
      }),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          setGenerateLink(data.data[0].token)
        }
      });
  }

  async function emailInvite() {
    await fetch(`${baseurl}/email/invite`, {
      method: "POST",
      body: JSON.stringify({
        name: UserName,
        mail_id: inviteEmail,
        url: generateLink
      }),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          setInvite(false)
        }
      });
  }

  async function fetchReferrals(search = "") {
    setReferralLoading(true);
    try {
      const response = await fetch(`${baseurl}/referral/list`, {
        method: "POST",
        body: JSON.stringify({
          user_id: USERID,
          search: search || ""
        }),
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${key}`,
        },
      });
      const data = await response.json();
      if (data?.status === true) {
        setReceivedReferrals(Array.isArray(data?.data?.received) ? data.data.received : []);
        setGivenReferrals(Array.isArray(data?.data?.given) ? data.data.given : []);
      } else {
        setReceivedReferrals([]);
        setGivenReferrals([]);
      }
    } catch (error) {
      console.error("Error fetching referrals:", error);
      setReceivedReferrals([]);
      setGivenReferrals([]);
    } finally {
      setReferralLoading(false);
    }
  }

  async function refreshCommunityAfterAction(options = {}) {
    const pinnedMembersPage = Number(options?.membersPage || membersPage || 1);
    const tasks = [
      fetchIncomingRequests(),
      fetchOutgoingRequests(),
      fetchConnections(connectionSearchTerm || ""),
      fetchReferrals(referralSearchTerm || ""),
    ];
    if (!options?.skipUserDetails) {
      tasks.push(userDetails());
    }
    if (!options?.skipCommunityList) {
      // Preserve current members pagination when a community list refresh is needed.
      tasks.push(fetchCommunityList(null, { membersPage: pinnedMembersPage, appendMembers: false }));
    }
    await Promise.all(tasks);
  }

  const textareaRef = useRef(null);
  const copyToClipboard = () => {
    if (textareaRef.current) {
      textareaRef.current.select();
      document.execCommand('copy');
      setInvite(false)
    }
  };

  useEffect(() => {
    anyoneSearch();
  }, [anyoneSearch])


  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchText.trim() !== "") {
        fetchCommunityList();
      }
    }, 500); // wait 500ms after user stops typing

    return () => clearTimeout(delayDebounce);
  }, [searchText]);

  // Refetch community list when search term or filter changes (only if searching)
  useEffect(() => {
    if (allsearch && allsearch.trim() !== "") {
      fetchCommunityList();
    }
  }, [allsearch, activeFilter, memberTypeFilter])

  useEffect(() => {
    // Club Members search must query backend across the full dataset,
    // then paginate filtered results.
    if (!key || !USERID || !OrgID) return;
    if (!(activeFilter === "Members" || (activeFilter === "All" && activeOverviewTab === "Members"))) return;

    const t = setTimeout(() => {
      setMembersPage(1);
      setMembersLoadingMore(true);
      fetchCommunityList(null, { membersPage: 1, appendMembers: false, searchTerm: memberSearchTerm || "" });
    }, 350);

    return () => clearTimeout(t);
  }, [memberSearchTerm, activeFilter, activeOverviewTab, memberTypeFilter, key, USERID, OrgID])

  useEffect(() => {
    // When user switches member type filter, refresh members list from API
    if (key && USERID && OrgID) {
      setMembersPage(1);
      fetchCommunityList(null, { membersPage: 1, appendMembers: false });
    }
  }, [memberTypeFilter])

  useEffect(() => {
    // When top-level filter changes, reset members pagination
    if (key && USERID && OrgID) {
      setMembersPage(1);
      fetchCommunityList(null, { membersPage: 1, appendMembers: false });
    }
  }, [activeFilter])

  useEffect(() => {
    setOpportunitiesOverviewPage(1);
    setOpportunitiesOverviewVisibleInPage(5);
  }, [memberSearchTerm, activeOverviewTab, opportunities.length]);

  useEffect(() => {
    setOpportunitiesTabPage(1);
    setOpportunitiesTabVisibleInPage(5);
  }, [opportunitySearchTerm, activeFilter, opportunities.length]);

  useEffect(() => {
    setOpportunitiesOverviewVisibleInPage(5);
  }, [opportunitiesOverviewPage]);

  useEffect(() => {
    setOpportunitiesTabVisibleInPage(5);
  }, [opportunitiesTabPage]);

  useEffect(() => {
    setEventsOverviewPage(1);
  }, [eventSearchTerm, activeOverviewTab, events.length]);

  useEffect(() => {
    setEventsTabPage(1);
  }, [eventSearchTerm, activeFilter, events.length]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (message !== "") {
        chatCreate()
      }
    }
  };

  useEffect(() => {
    function handleKeyPress(event) {
      if (event.key === 'Escape') {
        setPopup(false);
        setChat([])
      }
    }
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  useEffect(() => {
    const syncMobileFloatingView = () => {
      const mobile = window.innerWidth <= 1024;
      setIsMobileFloatingView(mobile);
      const widthChangedInFloatingMode = mobile && Math.abs(window.innerWidth - (lastFloatingViewportWidthRef.current || 0)) > 8;
      const heightChangedSignificantly = Math.abs(window.innerHeight - (lastFloatingViewportHeightRef.current || 0)) > 12;

      if (mobile !== mobileFloatingModeRef.current || widthChangedInFloatingMode || heightChangedSignificantly) {
        mobileFloatingModeRef.current = mobile;
        // Reset stale drag coordinates when switching viewport mode or when
        // viewport size changes (prevents fixed pixel top/left values drifting
        // away from centered FAB positions after resize).
        setIconPosition(null);
        setMeetingIconPosition(null);
      }

      lastFloatingViewportWidthRef.current = window.innerWidth;
      lastFloatingViewportHeightRef.current = window.innerHeight;
    };

    syncMobileFloatingView();
    window.addEventListener("resize", syncMobileFloatingView);
    return () => window.removeEventListener("resize", syncMobileFloatingView);
  }, []);

  useEffect(() => {
    const clampPosition = (pos, elRef) => {
      if (!pos || !elRef.current) return pos;
      const rect = elRef.current.getBoundingClientRect();
      const margin = 8;
      const maxX = Math.max(margin, window.innerWidth - rect.width - margin);
      const maxY = Math.max(margin, window.innerHeight - rect.height - margin);
      return {
        x: Math.max(margin, Math.min(pos.x, maxX)),
        y: Math.max(margin, Math.min(pos.y, maxY)),
      };
    };

    const onResize = () => {
      setIconPosition((prev) => clampPosition(prev, iconRef));
      setMeetingIconPosition((prev) => clampPosition(prev, meetingIconRef));
      setWhiteboardPosition((prev) => clampPosition(prev, whiteboardRef));
    };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const startMeeting = () => {
    try {
      const meetingUrl = generateMeetingUrl();
      window.open(meetingUrl, '_blank');
    } catch (error) {
      console.error('Error starting meeting:', error);
    }
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(email)) {
      return false;
    }
    const domain = email.split('@')[1];
    return domain.toLowerCase() === 'gmail.com';
  };

  useEffect(() => {
    console.log("chat called");
    if (firestoreid) {
      const roomRef = doc(db, 'chats', 'chatrooms', 'rooms', firestoreid);
      const messagesCollectionRef = collection(roomRef, 'Messages');
      const q = query(messagesCollectionRef, orderBy("server_time", "desc"),);

      const unsubscribe = onSnapshot(q, (QuerySnapshot) => {
        const fetchedMessages = [];
        QuerySnapshot.forEach((doc) => {
          fetchedMessages.push({ ...doc.data(), id: doc.id });
        });
        console.log(fetchedMessages);
        setChat(fetchedMessages);
      });
      return () => unsubscribe;
    }
  }, [firestoreid, trigger]);

  useEffect(() => {
    console.log(trigger);
  }, [trigger])

  const scroll = useRef();

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        await userDetails();
        await fetchCommunityList();
        await fetchIncomingRequests();
        await fetchOutgoingRequests();
        fetchOpportunities();
      } finally {
        setLoading(false);
      }
    };
    if (key && USERID) {
      load();
    } else {
      setLoading(false);
    }
  }, [key, USERID])

  useEffect(() => {
    if (activeFilter === "Connections") {
      const delay = connectionSearchTerm ? 400 : 0;
      const t = setTimeout(() => fetchConnections(connectionSearchTerm || ""), delay);
      return () => clearTimeout(t);
    }
  }, [activeFilter, connectionSearchTerm])

  useEffect(() => {
    // Always refresh from vacancies API when entering opportunities views
    // so users see the full list immediately without fallback flicker.
    if (!USERID) return;
    if (activeFilter === "Opportunities" || activeOverviewTab === "Opportunities") {
      fetchOpportunities();
    }
  }, [activeFilter, activeOverviewTab, USERID])

  useEffect(() => {
    if (activeFilter !== "Referrals") return;
    const delay = referralSearchTerm ? 350 : 0;
    const t = setTimeout(() => fetchReferrals(referralSearchTerm || ""), delay);
    return () => clearTimeout(t);
  }, [activeFilter, referralSearchTerm])

  useEffect(() => {
    if (activeFilter !== "All" || activeOverviewTab !== "Referrals") return;
    const delay = referralSearchTerm ? 350 : 0;
    const t = setTimeout(() => fetchReferrals(referralSearchTerm || ""), delay);
    return () => clearTimeout(t);
  }, [activeFilter, activeOverviewTab, referralSearchTerm])

  useEffect(() => {
    localStorage.setItem(REFERRAL_SUBTAB_STORAGE_KEY, referralSubTab);
  }, [referralSubTab])

  const inputRef = useRef(null);
  useEffect(() => {
    if (popup && inputRef.current) {
      inputRef.current.focus();
    }
  }, [popup]);

  const [closing, setClosing] = useState(false);

  const handleIconDragStart = useCallback((e) => {
    if (e.button !== 0) return;
    const icon = iconRef.current;
    if (!icon) return;
    const rect = icon.getBoundingClientRect();
    iconDragRef.current = {
      dragging: true,
      offsetX: e.clientX - rect.left,
      offsetY: e.clientY - rect.top,
    };
    e.preventDefault();
  }, []);

  const handleIconTouchStart = useCallback((e) => {
    const touch = e.touches?.[0];
    const icon = iconRef.current;
    if (!touch || !icon) return;
    const rect = icon.getBoundingClientRect();
    iconDragRef.current = {
      dragging: true,
      offsetX: touch.clientX - rect.left,
      offsetY: touch.clientY - rect.top,
    };
  }, []);

  const handleMeetingIconDragStart = useCallback((e) => {
    if (e.button !== 0) return;
    const icon = meetingIconRef.current;
    if (!icon) return;
    const rect = icon.getBoundingClientRect();
    meetingIconDragRef.current = {
      dragging: true,
      offsetX: e.clientX - rect.left,
      offsetY: e.clientY - rect.top,
    };
    e.preventDefault();
  }, []);

  const handleMeetingIconTouchStart = useCallback((e) => {
    const touch = e.touches?.[0];
    const icon = meetingIconRef.current;
    if (!touch || !icon) return;
    const rect = icon.getBoundingClientRect();
    meetingIconDragRef.current = {
      dragging: true,
      offsetX: touch.clientX - rect.left,
      offsetY: touch.clientY - rect.top,
    };
  }, []);

  const handleWhiteboardDragStart = useCallback((e) => {
    if (e.button !== 0) return;
    const wb = whiteboardRef.current;
    if (!wb) return;
    const rect = wb.getBoundingClientRect();
    whiteboardDragRef.current = {
      dragging: true,
      offsetX: e.clientX - rect.left,
      offsetY: e.clientY - rect.top,
    };
    setWhiteboardPosition({ x: rect.left, y: rect.top });
    e.preventDefault();
  }, []);

  useEffect(() => {
    const onMouseMove = (e) => {
      if (!whiteboardDragRef.current.dragging) return;
      const wb = whiteboardRef.current;
      if (!wb) return;
      const rect = wb.getBoundingClientRect();
      const margin = 8;
      const maxX = window.innerWidth - rect.width - margin;
      const maxY = window.innerHeight - rect.height - margin;
      const nextX = Math.max(margin, Math.min(e.clientX - whiteboardDragRef.current.offsetX, maxX));
      const nextY = Math.max(margin, Math.min(e.clientY - whiteboardDragRef.current.offsetY, maxY));
      setWhiteboardPosition({ x: nextX, y: nextY });
    };

    const onMouseUp = () => {
      whiteboardDragRef.current.dragging = false;
      iconDragRef.current.dragging = false;
      meetingIconDragRef.current.dragging = false;
    };

    const onIconMouseMove = (e) => {
      if (!iconDragRef.current.dragging) return;
      const icon = iconRef.current;
      if (!icon) return;
      const rect = icon.getBoundingClientRect();
      const margin = 8;
      const maxX = window.innerWidth - rect.width - margin;
      const maxY = window.innerHeight - rect.height - margin;
      const nextX = Math.max(margin, Math.min(e.clientX - iconDragRef.current.offsetX, maxX));
      const nextY = Math.max(margin, Math.min(e.clientY - iconDragRef.current.offsetY, maxY));
      setIconPosition({ x: nextX, y: nextY });
    };

    const onMeetingIconMouseMove = (e) => {
      if (!meetingIconDragRef.current.dragging) return;
      const icon = meetingIconRef.current;
      if (!icon) return;
      const rect = icon.getBoundingClientRect();
      const margin = 8;
      const maxX = window.innerWidth - rect.width - margin;
      const maxY = window.innerHeight - rect.height - margin;
      const nextX = Math.max(margin, Math.min(e.clientX - meetingIconDragRef.current.offsetX, maxX));
      const nextY = Math.max(margin, Math.min(e.clientY - meetingIconDragRef.current.offsetY, maxY));
      setMeetingIconPosition({ x: nextX, y: nextY });
    };

    const onIconTouchMove = (e) => {
      if (!iconDragRef.current.dragging) return;
      const icon = iconRef.current;
      const touch = e.touches?.[0];
      if (!icon || !touch) return;
      const rect = icon.getBoundingClientRect();
      const margin = 8;
      const maxX = window.innerWidth - rect.width - margin;
      const maxY = window.innerHeight - rect.height - margin;
      const nextX = Math.max(margin, Math.min(touch.clientX - iconDragRef.current.offsetX, maxX));
      const nextY = Math.max(margin, Math.min(touch.clientY - iconDragRef.current.offsetY, maxY));
      setIconPosition({ x: nextX, y: nextY });
      e.preventDefault();
    };

    const onMeetingIconTouchMove = (e) => {
      if (!meetingIconDragRef.current.dragging) return;
      const icon = meetingIconRef.current;
      const touch = e.touches?.[0];
      if (!icon || !touch) return;
      const rect = icon.getBoundingClientRect();
      const margin = 8;
      const maxX = window.innerWidth - rect.width - margin;
      const maxY = window.innerHeight - rect.height - margin;
      const nextX = Math.max(margin, Math.min(touch.clientX - meetingIconDragRef.current.offsetX, maxX));
      const nextY = Math.max(margin, Math.min(touch.clientY - meetingIconDragRef.current.offsetY, maxY));
      setMeetingIconPosition({ x: nextX, y: nextY });
      e.preventDefault();
    };

    const onTouchEnd = () => {
      iconDragRef.current.dragging = false;
      meetingIconDragRef.current.dragging = false;
    };

    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mousemove", onIconMouseMove);
    window.addEventListener("mousemove", onMeetingIconMouseMove);
    window.addEventListener("mouseup", onMouseUp);
    window.addEventListener("touchmove", onIconTouchMove, { passive: false });
    window.addEventListener("touchmove", onMeetingIconTouchMove, { passive: false });
    window.addEventListener("touchend", onTouchEnd);
    window.addEventListener("touchcancel", onTouchEnd);
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mousemove", onIconMouseMove);
      window.removeEventListener("mousemove", onMeetingIconMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
      window.removeEventListener("touchmove", onIconTouchMove);
      window.removeEventListener("touchmove", onMeetingIconTouchMove);
      window.removeEventListener("touchend", onTouchEnd);
      window.removeEventListener("touchcancel", onTouchEnd);
    };
  }, []);

  useEffect(() => {
    if (closing) {
      setTimeout(() => {
        setClosing(false)
      }, 1000);
    }
  }, [closing])

  useEffect(() => {
    console.log(USERID);
    if (USERID && USERID !== undefined && USERID !== null) {
      dispatch(UserProfile())
    }
  }, [USERID])

  useEffect(() => {
    if (profile && profile.Email) {
      setUserEmail(profile.Email)
    }
  }, [profile?.Email])

  useEffect(() => {
    if (location.state?.openCommunityTab === "Events") {
      setActiveFilter("Events");
      setActiveMemberSubMenu("Events");
      setActiveOverviewTab("Events");
    }
  }, [location.state?.openCommunityTab])

  useEffect(() => {
    const sectionToPersist = COMMUNITY_SECTIONS.includes(activeFilter) ? activeFilter : activeMemberSubMenu;
    if (COMMUNITY_SECTIONS.includes(sectionToPersist)) {
      localStorage.setItem(COMMUNITY_SECTION_STORAGE_KEY, sectionToPersist);
    }
  }, [activeFilter, activeMemberSubMenu]);

  useEffect(() => {
    // Club Network view should always show the in-card filter tabs on mobile.
    // Clearing global search text avoids switching to the alternate SearchDiv layout.
    if (activeFilter === "All" && searchText) {
      setSearchText("");
    }
  }, [activeFilter, searchText]);

  useEffect(() => {
    // Keep selected right-side tabs visible on narrow screens without reordering tabs.
    if (!["Opportunities", "Events", "Referrals"].includes(activeFilter)) return;
    const tabsEl = filterTabsRef.current;
    if (!tabsEl) return;
    const activeTab = tabsEl.querySelector(`.${style.ActiveFilterTab}`);
    if (!activeTab) return;
    activeTab.scrollIntoView({ behavior: "auto", inline: "center", block: "nearest" });
  }, [activeFilter]);

  useEffect(() => {
    const handleOutsideDropdownClick = (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      if (!target.closest('[data-member-type-dropdown="true"]')) {
        setMemberTypeDropdownOpen(false);
      }
    };
    const handleDropdownEscape = (event) => {
      if (event.key === "Escape") setMemberTypeDropdownOpen(false);
    };
    document.addEventListener("mousedown", handleOutsideDropdownClick);
    document.addEventListener("keydown", handleDropdownEscape);
    return () => {
      document.removeEventListener("mousedown", handleOutsideDropdownClick);
      document.removeEventListener("keydown", handleDropdownEscape);
    };
  }, []);

  const renderMemberTypeDropdown = (extraClass = "") => (
    <div
      data-member-type-dropdown="true"
      className={`${style.MemberTypeDropdown}${extraClass ? ` ${extraClass}` : ""}`}
    >
      <button
        type="button"
        className={`${style.MemberTypeSelect} ${style.MemberTypeDropdownButton} ${memberTypeDropdownOpen ? style.MemberTypeDropdownButtonOpen : ""}`}
        aria-label="Filter members by type"
        aria-haspopup="listbox"
        aria-expanded={memberTypeDropdownOpen}
        onClick={() => setMemberTypeDropdownOpen((prev) => !prev)}
      >
        <span>{memberTypeFilter}</span>
      </button>
      {memberTypeDropdownOpen && (
        <div className={style.MemberTypeDropdownMenu} role="listbox" aria-label="Member type options">
          {memberTypeOptions.map((option) => (
            <button
              key={option}
              type="button"
              className={`${style.MemberTypeDropdownOption} ${memberTypeFilter === option ? style.MemberTypeDropdownOptionActive : ""}`}
              role="option"
              aria-selected={memberTypeFilter === option}
              onClick={() => {
                setMemberTypeFilter(option);
                setMemberTypeDropdownOpen(false);
              }}
            >
              {option}
            </button>
          ))}
        </div>
      )}
    </div>
  );


  return (
    <>
      <div className={style.Container}>
        {/* Mobile menu icon is rendered near the search bar instead of floating top-left */}
        {lodaing && (
          <div className={style.loaderTop}>
            <Loader />
          </div>
        )}
        {whiteBoradIconShow ? (
          <div
            ref={iconRef}
            className={style.chatboticon}
            style={iconPosition ? { left: `${iconPosition.x}px`, top: `${iconPosition.y}px`, right: "auto", transform: "none" } : undefined}
          >
            <div
              onMouseDown={handleIconDragStart}
              onTouchStart={handleIconTouchStart}
              onClick={() => {
                setWhiteboardPosition(null);
                setWhiteBoardShow(true)
                setWhiteBoardIconShow(false)
              }}
              className={floatingStyles.icontext}
            >
              <BiClipboard className={floatingStyles.WhiteboardFloatingIcon} />
              <span className={floatingStyles.iconLabel}>Whiteboard</span>
            </div>
          </div>
        ) : (
          ""
        )}
        {meetingButton ? (
  <div
    ref={meetingIconRef}
    className={floatingStyles.Meetingicon}
    style={meetingIconPosition ? { left: `${meetingIconPosition.x}px`, top: `${meetingIconPosition.y}px`, right: "auto", bottom: "auto", transform: "none" } : undefined}
  >
    <div
      onMouseDown={handleMeetingIconDragStart}
      onTouchStart={handleMeetingIconTouchStart}
      onClick={() => {
        startMeeting()
      }}
      className={floatingStyles.MeetingiconText}
    >
      <SiGooglemeet className={floatingStyles.WhiteboardFloatingIcon} />
      <span className={floatingStyles.meetingLabel}>Start meeting</span>
      {userEmailError && (
        <span className={style.Error}>{userEmailError}</span>
      )}
    </div>
  </div>
) : (
  ""
)}
        {showNoDetailsPopup && (
          <>
            <div className={style.NoDetailsPopup}>
              <MdPerson className={style.NoDetailsPopupIcon} />
              <p>This user has not provided details.</p>
              <button className={style.NoDetailsPopupBtn} onClick={() => setShowNoDetailsPopup(false)}>OK</button>
            </div>
          </>
        )}
        {popup ?
          <>
            <div className={style.Overlay}></div>
            <div className={`${style.Popup} ${closing ? style.closing : ''}`}>
              {chatLoader ? <Loader /> : ''}
              <div className={style.popupHead}>
                <div className={style.HeadText}>
                  <p>{recever}</p>
                </div>
                <div
                  className={style.PopupIcon}
                  onClick={() => {
                    setTimeout(() => {
                      setPopup(false);
                      setLoading(false);
                      setChat([])
                    }, 500);
                    setClosing(true);
                  }}
                >
                  <AiOutlineClose />
                </div>
              </div>
              <div className={style.PopupContent} >
                {chat.map((message) => {
                  const isSenderMe = message.user_name === UserName;
                  return (
                    <div key={message.id} className={`${style.message} ${isSenderMe ? style.sender : style.receiver}`}>
                      {message.content}
                    </div>
                  )
                })}
                <span ref={scroll}></span>
              </div>

              <div className={style.BotInput}>
                <div className={style.Input}><input
                  ref={inputRef}
                  value={message}
                  onChange={(e) => {
                    setMessage(e.target.value)
                  }}
                  onKeyDown={handleKeyPress}
                  placeholder='Type a message...'
                  autoComplete="off"
                />

                </div>
                <IoSend className={style.Icon} onClick={() => {
                  if (message !== "") {
                    chatCreate()
                    setChatLoader(true)
                  }
                }} />
              </div>
            </div>
          </>
          : ''}
        {invite ?
          <div className={style.InvitePopupOverlay}>
            <div className={style.InvitePopup}>
              <div className={style.InvitePopupHead}>
                <p>Invite to join with you</p>
                <span onClick={() => {
                  setInvite(false)
                }} className={style.ClearIcon}><AiOutlineClose /></span>
              </div>
              <div className={style.InvitePopupContent}>
                <div className={style.Emailinput}>
                  <div>
                    <input value={inviteEmail} onChange={(e) => {
                      setInviteEmail(e.target.value)
                    }} type="email" placeholder='Enter Email Address' autoComplete="off"></input>
                    <button onClick={() => {
                      emailInvite()
                    }} disabled={inviteEmail === ""}>Invite</button>
                  </div>
                </div>
                <div className={style.IviteTextarea}>
                  <p>OR Share below Invitation link through your email, messenger or social media</p>
                  <textarea value={generateLink} rows="4" cols="50" ref={textareaRef} readOnly />
                  <div className={style.IviteTextareaButton}>
                    <button onClick={() => {
                      copyToClipboard()
                    }}>Copy Invitation Link</button>
                  </div>
                </div>
              </div>
            </div>

          </div>
          : ''}
        {whiteBoradShow ?
          <div
            ref={whiteboardRef}
            className={`${style.WhiteBoradContainer} ${closing ? style.closing : ''}`}
            style={whiteboardPosition ? { left: `${whiteboardPosition.x}px`, top: `${whiteboardPosition.y}px`, right: "auto", transform: "none" } : undefined}
          >
            <div className={style.WhiteBoradHead} onMouseDown={handleWhiteboardDragStart}>
              <div className={style.HeadText}>
                White Board
              </div>
              <div
                className={style.WhiteBoradIcon}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={() => {
                  setTimeout(() => {
                    setWhiteBoardIconShow(true)
                    setWhiteBoardShow(false)
                  }, 500);
                  setClosing(true);
                }}
              >
                <AiOutlineClose />
              </div>
            </div>
            <div className={style.WhiteBoradContent} >
              <Whiteboard />

            </div>

          </div>
          : ''}

        <div className={style.Support}>
          <div className={style.SubmenuAndContentRow}>
            <div className={style.MembersSubMenu}>
              <div className={style.SidebarTitle}>My Network</div>
              <div className={style.SidebarMenu}>
                <button
                  className={`${style.SidebarMenuItem} ${activeMemberSubMenu === "Members" ? style.ActiveSidebarMenuItem : ""}`}
                  onClick={() => {
                    setActiveMemberSubMenu("Members");
                    setActiveFilter("Members");
                  }}
                >
                  Club Members
                </button>
                <button
                  className={`${style.SidebarMenuItem} ${activeMemberSubMenu === "Connections" ? style.ActiveSidebarMenuItem : ""}`}
                  onClick={() => {
                    setActiveMemberSubMenu("Connections");
                    setActiveFilter("Connections");
                  }}
                >
                  My Connections
                </button>
                <button
                  className={`${style.SidebarMenuItem} ${activeMemberSubMenu === "Opportunities" ? style.ActiveSidebarMenuItem : ""}`}
                  onClick={() => {
                    setActiveMemberSubMenu("Opportunities");
                    setActiveFilter("Opportunities");
                  }}
                >
                  New Opportunities
                </button>
                <button
                  className={`${style.SidebarMenuItem} ${activeMemberSubMenu === "Events" ? style.ActiveSidebarMenuItem : ""}`}
                  onClick={() => {
                    setActiveMemberSubMenu("Events");
                    setActiveFilter("Events");
                  }}
                >
                  Upcoming Events
                </button>
                <button
                  className={`${style.SidebarMenuItem} ${activeMemberSubMenu === "Referrals" ? style.ActiveSidebarMenuItem : ""}`}
                  onClick={() => {
                    setActiveMemberSubMenu("Referrals");
                    setActiveFilter("Referrals");
                  }}
                >
                  Referrals
                </button>
              </div>
            </div>
            <div className={style.CommunityContent}>
              {!searchText ?
                <>
                  {/* Club Network (All) - single search bar + filters, sections with headlines only */}
                  {activeFilter === "All" && (
                    <div className={style.MainCard}>
                      <div className={style.MainCardHeader}>
                        <div className={style.MainCardHeaderColumn}>
                          <div className={style.SearchRow}>
                            {typeof onMenuToggle === "function" && !sidebarOpen && (
                              <button
                                type="button"
                                className={style.mobileHeaderMenuBtn}
                                onClick={onMenuToggle}
                                aria-label="Open menu"
                              >
                                <MdMoreVert size={20} />
                              </button>
                            )}
                            <div className={style.SectionSearchBar}>
                              <AiOutlineSearch className={style.SearchIcon} />
                              <input
                                className={style.SearchInput}
                                type="text"
                                placeholder={`Search ${activeOverviewTab === "Members"
                                  ? "club members"
                                  : activeOverviewTab === "Connections"
                                    ? "connections"
                                    : activeOverviewTab === "Opportunities"
                                      ? "opportunities"
                                      : activeOverviewTab === "Events"
                                        ? "events"
                                        : "referrals"}...`}
                                autoComplete="off"
                                value={activeOverviewTab === "Events"
                                  ? eventSearchTerm
                                  : activeOverviewTab === "Referrals"
                                    ? referralSearchTerm
                                    : memberSearchTerm}
                                onChange={(e) => {
                                  if (activeOverviewTab === "Events") {
                                    setEventSearchTerm(e.target.value);
                                  } else if (activeOverviewTab === "Referrals") {
                                    setReferralSearchTerm(e.target.value);
                                  } else {
                                    setMemberSearchTerm(e.target.value);
                                  }
                                }}
                              />
                            </div>
                            {(activeOverviewTab === "Members" || activeFilter === "Members") && renderMemberTypeDropdown()}
                          </div>
                          <div className={style.CardFilterTabsWrapper}>
                            <button type="button" className={style.FilterScrollIndicator} aria-label="Scroll left" onClick={() => scrollFilterTabs(-1)}>
                              <IoChevronBack />
                            </button>
                            <div ref={filterTabsRef} className={style.CardFilterTabs}>
                            <button className={`${style.FilterTab} ${style.tabClubMembers} ${activeOverviewTab === "Members" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveOverviewTab("Members"); setActiveMemberSubMenu("Members"); }}>Club Members</button>
                            <button className={`${style.FilterTab} ${style.tabMyConnections} ${activeOverviewTab === "Connections" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveOverviewTab("Connections"); setActiveMemberSubMenu("Connections"); }}>My Connections</button>
                            <button className={`${style.FilterTab} ${activeOverviewTab === "Opportunities" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveOverviewTab("Opportunities"); setActiveMemberSubMenu("Opportunities"); }}>New Opportunities</button>
                            <button className={`${style.FilterTab} ${activeOverviewTab === "Events" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveOverviewTab("Events"); setActiveMemberSubMenu("Events"); }}>Upcoming Events</button>
                            <button className={`${style.FilterTab} ${activeOverviewTab === "Referrals" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveOverviewTab("Referrals"); setActiveMemberSubMenu("Referrals"); }}>Referrals</button>
                          </div>
                            <button type="button" className={style.FilterScrollIndicator} aria-label="Scroll right" onClick={() => scrollFilterTabs(1)}>
                              <IoChevronForward />
                            </button>
                          </div>
                        </div>
                      </div>
                      {activeOverviewTab === "Members" && (
                      <div className={style.SectionWithHeadline}>
                        <div className={style.SectionHeaderRow}>
                          {renderMemberTypeDropdown(style.MemberTypeSelectHeader)}
                        </div>
                        <div className={style.FirstDiv}>
                          {isMembersSearchLoading ? (
                            <Loader />
                          ) : details && details.length > 0 ? (() => {
                            const filteredMembers = details.filter(user => {
                              if (!memberSearchTerm) return true;
                              const searchLower = memberSearchTerm.toLowerCase();
                              return (
                                (user.Username || user.username || user.username || "")?.toLowerCase().includes(searchLower) ||
                                (user.Email || user.email || "")?.toLowerCase().includes(searchLower) ||
                                (user.role || user.Role || "")?.toLowerCase().includes(searchLower) ||
                                (user.About || "")?.toLowerCase().includes(searchLower)
                              );
                            });
                            const maxMembersWhenExpanded = MEMBERS_SECTION_LIMIT * 2;
                            const visibleMembers = filteredMembers.slice(
                              0,
                              sectionExpanded.members ? maxMembersWhenExpanded : MEMBERS_SECTION_LIMIT
                            );
                            const hiddenMembersCount = Math.max(
                              0,
                              Math.min(filteredMembers.length, maxMembersWhenExpanded) - MEMBERS_SECTION_LIMIT
                            );
                            return (
                              <>
                                {filteredMembers.length > 0 && membersTotalPages > 1 && (
                                  <div className={style.PaginationCenter}>
                                    <button
                                      type="button"
                                      className={style.MoreRecordsBtn}
                                      disabled={membersLoadingMore || membersPage <= 1}
                                      onClick={() => {
                                        const prev = (membersPage || 1) - 1;
                                        setMembersLoadingMore(true);
                                        fetchCommunityList(null, { membersPage: prev, appendMembers: false });
                                      }}
                                    >
                                      {membersLoadingMore ? "Loading..." : "Previous"}
                                    </button>
                                    <div className={style.PageNumbers} aria-label={`Pagination, page ${membersPage} of ${membersTotalPages || 1}`}>
                                      {getPageItems(membersPage, membersTotalPages).map((it, idx) => (
                                        it === "…" ? (
                                          <span key={`ellipsis-${idx}`} className={style.PageEllipsis}>…</span>
                                        ) : (
                                          <button
                                            key={`page-${it}`}
                                            type="button"
                                            className={`${style.PageBadge} ${Number(it) === Number(membersPage) ? style.PageBadgeActive : ""}`}
                                            disabled={membersLoadingMore}
                                            onClick={() => {
                                              const target = Number(it);
                                              if (!target || target === membersPage) return;
                                              setMembersLoadingMore(true);
                                              fetchCommunityList(null, { membersPage: target, appendMembers: false });
                                            }}
                                            aria-label={`Go to page ${it}`}
                                          >
                                            {it}
                                          </button>
                                        )
                                      ))}
                                    </div>
                                    <button
                                      type="button"
                                      className={style.MoreRecordsBtn}
                                      disabled={membersLoadingMore || membersPage >= membersTotalPages}
                                      onClick={() => {
                                        const next = (membersPage || 1) + 1;
                                        setMembersLoadingMore(true);
                                        fetchCommunityList(null, { membersPage: next, appendMembers: false });
                                      }}
                                    >
                                      {membersLoadingMore ? "Loading..." : "Next"}
                                    </button>
                                  </div>
                                )}
                                {filteredMembers.length === 0 ? (
                                  <div className={style.NoEventsMessage}>
                                    <p>No results found</p>
                                  </div>
                                ) : visibleMembers.map((user, index) => (
                            <div
                              key={index}
                              className={style.MemberCard}
                              onClick={() => handleUserClick(user._id, user.role || user.Role)}
                              style={{ cursor: "pointer" }}
                            >
                              <div className={style.MemberCardContent}>
                                <div className={style.MemberCardHeader}>
                                  <div className={style.MemberCardAvatar}>
                                    <img src={getProfileSrc(user.profile_image || user.profile)} alt={user.Username || user.username} onError={handleProfileImageError} />
                                  </div>
                                  <div className={style.MemberCardInfo}>
                                    <div className={style.EventTitle}>
                                      {user.Username || user.username}{(user.role || user.Role) ? <> <span className={style.RoleBadge}>{getRoleLabel(user.role || user.Role)}</span></> : ''}
                                    </div>
                                    <div className={style.EventDetails}>
                                      {user.About && (
                                        <div className={style.EventDetailItem}>
                                          <span className={style.EventLabel}>About:</span>
                                          <span className={style.EventValue}>{user.About}</span>
                                        </div>
                                      )}
                                      {user.Experience && (
                                        <div className={style.EventDetailItem}>
                                          <span className={style.EventLabel}>Experience:</span>
                                          <span className={style.EventValue}>{user.Experience} Years</span>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className={style.MemberCardActions} onClick={(e) => e.stopPropagation()}>
                                    {(user.connection_status === "accepted" || user.already_mentor === true) ? (
                                      <>
                                        {isMentor && !["organization admin", "org admin"].includes(String(user.role || user.Role || "").toLowerCase()) && (
                                          <button
                                            className={style.MessageButton}
                                            onClick={() => {
                                              navigate("/user/learning", {
                                                state: {
                                                  userID: user._id,
                                                  username: user.Username || user.username,
                                                  peerRole: user.role || user.Role,
                                                },
                                              });
                                            }}
                                          >
                                            Learnings
                                          </button>
                                        )}
                                        <button className={style.IconButton} onClick={(e) => { e.stopPropagation(); setPopup(true); setRecever(user.Username || user.username); setReceverID(user._id); roomCreate(user.Username || user.username, user._id); setChatLoader(true); }} title="Message"><BsChatDots /></button>
                                      </>
                                    ) : (
                                      <>
                                        <button
                                          className={`${style.ConnectButton} ${(buttonState[user._id]) || isConnectionRequestSent(user) ? style.ConnectButtonRequested : ''}`}
                                          disabled={(buttonState[user._id]) || isConnectionRequestSent(user)}
                                          onClick={(e) => { e.stopPropagation(); requestSend(user._id, user.Username || user.username); }}
                                        >
                                          {(buttonState[user._id]) || isConnectionRequestSent(user) ? (
                                            <>
                                              <IoTimeOutline className={style.ConnectButtonIcon} />
                                              {((user.connection_status || "").toLowerCase() === "accepted") ? "Connected" : "Pending"}
                                            </>
                                          ) : (
                                            <>
                                              <BsPersonPlus className={style.ConnectButtonIcon} />
                                              Connect
                                            </>
                                          )}
                                        </button>
                                        {isMentor && !["organization admin", "org admin"].includes(String(user.role || user.Role || "").toLowerCase()) && (
                                          <button
                                            className={style.MessageButton}
                                            onClick={(e) => {
                                              navigate("/user/learning", {
                                                state: {
                                                  userID: user._id,
                                                  username: user.Username || user.username,
                                                  peerRole: user.role || user.Role,
                                                },
                                              });
                                            }}
                                          >
                                            Learnings
                                          </button>
                                        )}
                                        <button className={style.IconButton} onClick={(e) => { e.stopPropagation(); setPopup(true); setRecever(user.Username || user.username); setReceverID(user._id); roomCreate(user.Username || user.username, user._id); setChatLoader(true); }} title="Message"><BsChatDots /></button>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                                {membersTotalPages <= 1 && filteredMembers.length > MEMBERS_SECTION_LIMIT && (
                                  <div className={style.SeeMoreContainer}>
                                    <button className={style.SeeMoreButton} onClick={() => setSectionExpanded(prev => ({ ...prev, members: !prev.members }))}>
                                      {sectionExpanded.members ? "See less" : `See more (${hiddenMembersCount} more)`}
                                    </button>
                                  </div>
                                )}
                              </>
                            );
                          })() : <div>
                            {!lodaing ?
                              <p> "Oops ! There are many learners and mentors who wants to connect with you. You have not found them yet? Search and request for new connections."</p>
                              : ''}
                          </div>}
                        </div>
                      </div>
                      )}
                      {activeOverviewTab === "Events" && (
                      <div className={style.SectionWithHeadline}>
                        <h3 className={style.SectionHeadline}>Upcoming Events</h3>
                        <div className={style.FirstDiv}>
                          {eventsLoading && !lodaing ? (
                            <Loader />
                          ) : events && events.length > 0 ? (
                            (() => {
                              const filteredEvents = events.filter(event => {
                                if (!eventSearchTerm.trim()) return true;
                                const searchLower = eventSearchTerm.toLowerCase();
                                return (
                                  (event.event_title || event.title || "").toLowerCase().includes(searchLower) ||
                                  (event.host_name || "").toLowerCase().includes(searchLower) ||
                                  (event.event_mode || "").toLowerCase().includes(searchLower)
                                );
                              });
                              if (!filteredEvents.length) {
                                return (
                                  <div className={style.NoEventsMessage}>
                                    <p>No matching events found</p>
                                  </div>
                                );
                              }
                              const totalEventPages = Math.max(1, Math.ceil(filteredEvents.length / EVENTS_PAGE_SIZE));
                              const currentEventPage = Math.min(eventsOverviewPage, totalEventPages);
                              const startEventIndex = (currentEventPage - 1) * EVENTS_PAGE_SIZE;
                              const displayEvents = filteredEvents.slice(startEventIndex, startEventIndex + EVENTS_PAGE_SIZE);
                              return (
                                <>
                                  {displayEvents.map((event, index) => (
                              <div
                                key={index}
                                className={style.EventCard}
                                onClick={() => {
                                  localStorage.setItem("eventId", event.event_id);
                                  localStorage.setItem("eventName", event.event_title || event.title || "Untitled Event");
                                  navigate("/event/details");
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <div className={style.EventCardContent}>
                                  <div className={style.EventTitle}>
                                    {event.event_title || event.title || "Untitled Event"}
                                  </div>
                                  <div className={style.EventDetails}>
                                    {event.host_name && (
                                      <div className={style.EventDetailItem}>
                                        <span className={style.EventLabel}>Host:</span>
                                        <span className={style.EventValue}>{event.host_name}</span>
                                      </div>
                                    )}
                                    {event.event_mode && (
                                      <div className={style.EventDetailItem}>
                                        <span className={style.EventLabel}>Mode:</span>
                                        <span className={style.EventValue}>{event.event_mode}</span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                                  {totalEventPages > 1 && (
                                    <div className={style.PaginationCenter} style={{ borderBottom: "none", marginBottom: 0 }}>
                                      <button
                                        type="button"
                                        className={style.MoreRecordsBtn}
                                        disabled={currentEventPage <= 1}
                                        onClick={() => setEventsOverviewPage((p) => Math.max(1, p - 1))}
                                      >
                                        Prev
                                      </button>
                                      <div className={style.PageNumbers} aria-label={`Pagination, page ${currentEventPage} of ${totalEventPages}`}>
                                        {getPageItems(currentEventPage, totalEventPages).map((it, idx) => (
                                          typeof it === "string" ? (
                                            <span key={`ev-overview-ellipsis-${idx}`} className={style.PageEllipsis}>...</span>
                                          ) : (
                                            <button
                                              key={`ev-overview-page-${it}`}
                                              type="button"
                                              className={`${style.PageBadge} ${Number(it) === Number(currentEventPage) ? style.PageBadgeActive : ""}`}
                                              onClick={() => setEventsOverviewPage(Number(it))}
                                            >
                                              {it}
                                            </button>
                                          )
                                        ))}
                                      </div>
                                      <button
                                        type="button"
                                        className={style.MoreRecordsBtn}
                                        disabled={currentEventPage >= totalEventPages}
                                        onClick={() => setEventsOverviewPage((p) => Math.min(totalEventPages, p + 1))}
                                      >
                                        Next
                                      </button>
                                    </div>
                                  )}
                                </>
                              );
                            })()
                          ) : (
                            <div className={style.NoEventsMessage}>
                              <p>No upcoming events</p>
                            </div>
                          )}
                        </div>
                      </div>
                      )}
                      {activeOverviewTab === "Connections" && (
                      <div className={style.SectionWithHeadline}>
                        <div className={style.SectionHeaderRow}>
                          <h3 className={style.SectionHeadline}>My Connections</h3>
                          <span className={style.RequestLink} onClick={() => navigate("/requests")}>
                            <IoMailUnreadOutline /> Requests
                            {requestCount > 0 && <span className={style.RequestCountBadge}>{requestCount}</span>}
                            {sentRequestCount > 0 && (
                              <span className={style.SentRequestCountBadge} title="Pending requests you sent">
                                {sentRequestCount}
                              </span>
                            )}
                            <IoChevronForward className={style.RequestArrow} />
                          </span>
                        </div>
                        <div className={style.FirstDiv}>
                          {details && details.length > 0 ? (() => {
                            const filteredConnections = details.filter(user => {
                              return (user.role === "Intern" || user.role === "Learner" || user.role === "Mentor") &&
                                (user.connection_status === "accepted" || user.already_mentor === true);
                            }).filter(user => {
                              if (!memberSearchTerm.trim()) return true;
                              const searchLower = memberSearchTerm.toLowerCase();
                              return (
                                (user.Username || user.username || user.username || "")?.toLowerCase().includes(searchLower) ||
                                (user.Email || user.email || "")?.toLowerCase().includes(searchLower) ||
                                user.role?.toLowerCase().includes(searchLower) ||
                                (user.About || "")?.toLowerCase().includes(searchLower)
                              );
                            });
                            const displayConnections = sectionExpanded.connections ? filteredConnections : filteredConnections.slice(0, SECTION_LIMIT);
                            return (
                              <>
                                {displayConnections.map((user, index) => (
                            <div key={index} className={style.FirstCard}>
                              <div className={style.Image}>
                                <div className={style.imageDiv}>
                                  <img src={getProfileSrc(user.profile)} alt={user.Username || user.username} onError={handleProfileImageError} />
                                </div>
                              </div>
                              <div className={style.Content}>
                                <div className={style.CardHeader} onClick={() => handleUserClick(user._id, user.role)}>
                                  <div className={style.NameRow}>
                                    <h3 className={style.UserName}>{user.Username || user.username}{(user.role || user.Role) ? <> <span className={style.RoleBadge}>{getRoleLabel(user.role || user.Role)}</span></> : ''}</h3>
                                  </div>
                                  {user.About && <p className={style.Bio}>{user.About}</p>}
                                  {user.Experience && <p className={style.Location}>{user.Experience} Years of Experience</p>}
                                </div>
                                <div className={style.ActionButtons}>
                                  {user.role !== "Mentor" && (
                                    <button className={style.IconButton} onClick={(e) => { e.stopPropagation(); localStorage.setItem("learnertoken", user.token); localStorage.setItem("learneruserid", user._id); navigate("/learnings", { state: { token: user.token, username: user.Username || user.username, userID: user._id, peerRole: user.role, source: "support" } }); }} title="Learning"><SiBookstack /></button>
                                  )}
                                  <button className={style.IconButton} onClick={(e) => { e.stopPropagation(); navigate("/usercalendar", { state: { userid: user._id, username: user.Username || user.username, Role: user.role } }); }} title="Calendar"><MdCalendarMonth /></button>
                                  <button className={style.MessageButton} onClick={(e) => { e.stopPropagation(); setPopup(true); setRecever(user.Username || user.username); setReceverID(user._id); roomCreate(user.Username || user.username, user._id); setChatLoader(true); }}>Message</button>
                                </div>
                              </div>
                            </div>
                          ))}
                                {filteredConnections.length > SECTION_LIMIT && (
                                  <div className={style.SeeMoreContainer}>
                                    <button className={style.SeeMoreButton} onClick={() => setSectionExpanded(prev => ({ ...prev, connections: !prev.connections }))}>
                                      {sectionExpanded.connections ? "See less" : `See more (${filteredConnections.length - SECTION_LIMIT} more)`}
                                    </button>
                                  </div>
                                )}
                              </>
                            );
                          })() : (
                            <div className={style.NoEventsMessage}>
                              <p>No connections yet. Connect with members to build your network.</p>
                            </div>
                          )}
                        </div>
                      </div>
                      )}
                      {activeOverviewTab === "Opportunities" && (
                      <div className={style.SectionWithHeadline}>
                        <h3 className={style.SectionHeadline}>New Opportunities</h3>
                        <div className={style.OpportunitiesContainer}>
                          {opportunitiesLoading && !lodaing ? (
                            <Loader />
                          ) : opportunities && opportunities.length > 0 ? (
                            (() => {
                              const filteredOpportunities = opportunities.filter(opportunity => {
                                if (!memberSearchTerm.trim()) return true;
                                const searchLower = memberSearchTerm.toLowerCase();
                                return (
                                  (opportunity.job_title || opportunity.name || "").toLowerCase().includes(searchLower) ||
                                  (opportunity.designation || "").toLowerCase().includes(searchLower) ||
                                  (opportunity.job_description || opportunity.description || "").toLowerCase().includes(searchLower)
                                );
                              });
                              const totalOpportunityPages = Math.max(1, Math.ceil(filteredOpportunities.length / OPPORTUNITIES_PAGE_SIZE));
                              const currentOpportunityPage = Math.min(opportunitiesOverviewPage, totalOpportunityPages);
                              const startIndex = (currentOpportunityPage - 1) * OPPORTUNITIES_PAGE_SIZE;
                              const pageOpportunities = filteredOpportunities.slice(startIndex, startIndex + OPPORTUNITIES_PAGE_SIZE);
                              const displayOpportunities = pageOpportunities.slice(0, opportunitiesOverviewVisibleInPage);
                              return (
                                <div className={style.OpportunitiesList}>
                                  {totalOpportunityPages > 1 && (
                                    <div className={style.PaginationCenter}>
                                      <button
                                        type="button"
                                        className={style.MoreRecordsBtn}
                                        disabled={currentOpportunityPage <= 1}
                                        onClick={() => setOpportunitiesOverviewPage((p) => Math.max(1, p - 1))}
                                      >
                                        Previous
                                      </button>
                                      <div className={style.PageNumbers} aria-label={`Pagination, page ${currentOpportunityPage} of ${totalOpportunityPages}`}>
                                        {getPageItems(currentOpportunityPage, totalOpportunityPages).map((it, idx) => (
                                          typeof it === "string" ? (
                                            <span key={`op-overview-ellipsis-${idx}`} className={style.PageEllipsis}>...</span>
                                          ) : (
                                            <button
                                              key={`op-overview-page-${it}`}
                                              type="button"
                                              className={`${style.PageBadge} ${Number(it) === Number(currentOpportunityPage) ? style.PageBadgeActive : ""}`}
                                              onClick={() => setOpportunitiesOverviewPage(Number(it))}
                                            >
                                              {it}
                                            </button>
                                          )
                                        ))}
                                      </div>
                                      <button
                                        type="button"
                                        className={style.MoreRecordsBtn}
                                        disabled={currentOpportunityPage >= totalOpportunityPages}
                                        onClick={() => setOpportunitiesOverviewPage((p) => Math.min(totalOpportunityPages, p + 1))}
                                      >
                                        Next
                                      </button>
                                    </div>
                                  )}
                                  {displayOpportunities.map((opportunity, index) => (
                                <div
                                  key={index}
                                  className={style.OpportunityCard}
                                  onClick={() => navigate(`/job-view/${opportunity.id || opportunity._id || opportunity.vacancy_id}`)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <div className={style.OpportunityContent}>
                                    <div className={style.OpportunityMain}>
                                      <h3 className={style.OpportunityTitle}>
                                        {opportunity.job_title || opportunity.name || "-"} / {opportunity.designation}
                                      </h3>
                                      <p className={style.OpportunityDescription}>
                                        {opportunity.job_description || opportunity.description || "-"}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              ))}
                                  {(displayOpportunities.length < pageOpportunities.length || opportunitiesOverviewVisibleInPage > SECTION_LIMIT) && (
                                    <div className={style.SeeMoreContainer}>
                                      <button
                                        type="button"
                                        className={style.SeeMoreButton}
                                        onClick={() => {
                                          if (displayOpportunities.length < pageOpportunities.length) {
                                            setOpportunitiesOverviewVisibleInPage((c) =>
                                              Math.min(c + 5, pageOpportunities.length)
                                            );
                                          } else {
                                            setOpportunitiesOverviewVisibleInPage(SECTION_LIMIT);
                                          }
                                        }}
                                      >
                                        {displayOpportunities.length < pageOpportunities.length ? "Show more" : "Show less"}
                                      </button>
                                    </div>
                                  )}
                                </div>
                              );
                            })()
                          ) : (
                            <div>
                              <p>No opportunities found</p>
                            </div>
                          )}
                        </div>
                      </div>
                      )}
                      {activeOverviewTab === "Referrals" && (
                      <div className={style.SectionWithHeadline}>
                        <div className={style.SectionHeaderRow}>
                          <div className={style.ReferralHeaderSwitch}>
                            <span className={style.ReferralLabel}>Received</span>
                            <Switch
                              onChange={(checked) => setReferralSubTab(checked ? "Given" : "Received")}
                              checked={referralSubTab === "Given"}
                              offColor="#0151CD"
                              onColor="#0151CD"
                              checkedIcon={false}
                              uncheckedIcon={false}
                              height={24}
                              width={48}
                            />
                            <span className={style.ReferralLabel}>Given</span>
                          </div>
                        </div>
                        <div className={style.FirstDiv}>
                          {referralLoading ? (
                            <Loader />
                          ) : (
                            (() => {
                              const currentList = referralSubTab === "Received" ? receivedReferrals : givenReferrals;
                              if (!currentList.length) {
                                return (
                                  <div className={style.NoEventsMessage}>
                                    <p>{referralSubTab === "Received" ? "No received referrals found." : "No given referrals found."}</p>
                                  </div>
                                );
                              }
                              return currentList.map((user, index) => (
                                <div
                                  key={`${user.user_id || "ref"}-${index}`}
                                  className={style.MemberCard}
                                  onClick={() => user.user_id && handleUserClick(user.user_id, user.role)}
                                  style={{ cursor: user.user_id ? "pointer" : "default" }}
                                >
                                  <div className={style.MemberCardContent}>
                                    <div className={style.MemberCardHeader}>
                                      <div className={style.MemberCardAvatar}>
                                        <img src={getProfileSrc(user.profile)} alt={user.username || "Referral user"} onError={handleProfileImageError} />
                                      </div>
                                      <div className={style.MemberCardInfo}>
                                        <div className={style.EventTitle}>
                                          {user.username
                                            ? `${user.username}${user.email ? ` (${user.email})` : ""}`
                                            : (user.email || "Unknown User")}
                                          {user.role ? <> <span className={style.RoleBadge}>{user.role}</span></> : ""}
                                        </div>
                                        <div className={style.EventDetails}>
                                          {!user.username && user.email && (
                                            <div className={style.EventDetailItem}>
                                              <span className={style.EventLabel}>Email:</span>
                                              <span className={style.EventValue}>{user.email}</span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ));
                            })()
                          )}
                        </div>
                      </div>
                      )}
                    </div>
                  )}

                  {/* Club Members - search bar + filters only when this tab is selected */}
                  {activeFilter === "Members" && (
                    <div className={style.MainCard}>
                      <div className={style.MainCardHeader}>
                        <div className={style.MainCardHeaderColumn}>
                          <div className={style.SearchRow}>
                            {typeof onMenuToggle === "function" && !sidebarOpen && (
                              <button
                                type="button"
                                className={style.mobileHeaderMenuBtn}
                                onClick={onMenuToggle}
                                aria-label="Open menu"
                              >
                                <MdMoreVert size={20} />
                              </button>
                            )}
                            <div className={style.SectionSearchBar}>
                              <AiOutlineSearch className={style.SearchIcon} />
                              <input
                                className={style.SearchInput}
                                type="text"
                                placeholder="Search members..."
                                autoComplete="off"
                                value={memberSearchTerm}
                                onChange={(e) => setMemberSearchTerm(e.target.value)}
                              />
                            </div>
                            {renderMemberTypeDropdown()}
                          </div>
                          <div className={style.CardFilterTabsWrapper}>
                            <button type="button" className={style.FilterScrollIndicator} aria-label="Scroll left" onClick={() => scrollFilterTabs(-1)}>
                              <IoChevronBack />
                            </button>
                            <div ref={filterTabsRef} className={style.CardFilterTabs}>
                              <button className={`${style.FilterTab} ${style.tabClubMembers} ${activeFilter === "Members" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Members"); setActiveMemberSubMenu("Members"); }}>Club Members</button>
                              <button className={`${style.FilterTab} ${style.tabMyConnections} ${activeFilter === "Connections" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Connections"); setActiveMemberSubMenu("Connections"); setSearchText(""); }}>My Connections</button>
                              <button className={`${style.FilterTab} ${activeFilter === "Opportunities" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Opportunities"); setActiveMemberSubMenu("Opportunities"); }}>New Opportunities</button>
                              <button className={`${style.FilterTab} ${activeFilter === "Events" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Events"); setActiveMemberSubMenu("Events"); }}>Upcoming Events</button>
                              <button className={`${style.FilterTab} ${activeFilter === "Referrals" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Referrals"); setActiveMemberSubMenu("Referrals"); }}>Referrals</button>
                            </div>
                            <button type="button" className={style.FilterScrollIndicator} aria-label="Scroll right" onClick={() => scrollFilterTabs(1)}>
                              <IoChevronForward />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className={style.FirstDiv}>
                        {isMembersSearchLoading ? (
                          <Loader />
                        ) : details && details.length > 0 ? (() => {
                          const filteredMembersTab = details.filter(user => {
                            if (!memberSearchTerm) return true;
                            const searchLower = memberSearchTerm.toLowerCase();
                            return (
                              (user.Username || user.username || user.username || "")?.toLowerCase().includes(searchLower) ||
                              (user.Email || user.email || "")?.toLowerCase().includes(searchLower) ||
                              (user.role || user.Role || "")?.toLowerCase().includes(searchLower) ||
                              (user.About || "")?.toLowerCase().includes(searchLower)
                            );
                          });
                          const maxMembersWhenExpandedTab = MEMBERS_SECTION_LIMIT * 2;
                          const visibleMembersTab = filteredMembersTab.slice(
                            0,
                            sectionExpanded.membersTab ? maxMembersWhenExpandedTab : MEMBERS_SECTION_LIMIT
                          );
                          const hiddenMembersCountTab = Math.max(
                            0,
                            Math.min(filteredMembersTab.length, maxMembersWhenExpandedTab) - MEMBERS_SECTION_LIMIT
                          );
                          return (
                            <>
                              {filteredMembersTab.length > 0 && membersTotalPages > 1 && (
                                <div className={style.PaginationCenter}>
                                  <button
                                    type="button"
                                    className={style.MoreRecordsBtn}
                                    disabled={membersLoadingMore || membersPage <= 1}
                                    onClick={() => {
                                      const prev = (membersPage || 1) - 1;
                                      setMembersLoadingMore(true);
                                      fetchCommunityList(null, { membersPage: prev, appendMembers: false });
                                    }}
                                  >
                                    {membersLoadingMore ? "Loading..." : "Previous"}
                                  </button>
                                  <div className={style.PageNumbers} aria-label={`Pagination, page ${membersPage} of ${membersTotalPages || 1}`}>
                                    {getPageItems(membersPage, membersTotalPages).map((it, idx) => (
                                      it === "…" ? (
                                        <span key={`ellipsis-tab-${idx}`} className={style.PageEllipsis}>…</span>
                                      ) : (
                                        <button
                                          key={`page-tab-${it}`}
                                          type="button"
                                          className={`${style.PageBadge} ${Number(it) === Number(membersPage) ? style.PageBadgeActive : ""}`}
                                          disabled={membersLoadingMore}
                                          onClick={() => {
                                            const target = Number(it);
                                            if (!target || target === membersPage) return;
                                            setMembersLoadingMore(true);
                                            fetchCommunityList(null, { membersPage: target, appendMembers: false });
                                          }}
                                          aria-label={`Go to page ${it}`}
                                        >
                                          {it}
                                        </button>
                                      )
                                    ))}
                                  </div>
                                  <button
                                    type="button"
                                    className={style.MoreRecordsBtn}
                                    disabled={membersLoadingMore || membersPage >= membersTotalPages}
                                    onClick={() => {
                                      const next = (membersPage || 1) + 1;
                                      setMembersLoadingMore(true);
                                      fetchCommunityList(null, { membersPage: next, appendMembers: false });
                                    }}
                                  >
                                    {membersLoadingMore ? "Loading..." : "Next"}
                                  </button>
                                </div>
                              )}
                              {filteredMembersTab.length === 0 ? (
                                <div className={style.NoEventsMessage}>
                                  <p>No results found</p>
                                </div>
                              ) : visibleMembersTab.map((user, index) => (
                                <div
                                  key={index}
                                  className={style.MemberCard}
                                  onClick={() => handleUserClick(user._id, user.role)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <div className={style.MemberCardContent}>
                                    <div className={style.MemberCardHeader}>
                                      <div className={style.MemberCardAvatar}>
                                        <img src={getProfileSrc(user.profile_image || user.profile)} alt={user.Username || user.username} onError={handleProfileImageError} />
                                      </div>
                                      <div className={style.MemberCardInfo}>
                                        <div className={style.EventTitle}>
                                          {user.Username || user.username}{(user.role || user.Role) ? <> <span className={style.RoleBadge}>{getRoleLabel(user.role || user.Role)}</span></> : ''}
                                        </div>
                                        <div className={style.EventDetails}>
                                          {user.About && (
                                            <div className={style.EventDetailItem}>
                                              <span className={style.EventLabel}>About:</span>
                                              <span className={style.EventValue}>{user.About}</span>
                                            </div>
                                          )}
                                          {user.Experience && (
                                            <div className={style.EventDetailItem}>
                                              <span className={style.EventLabel}>Experience:</span>
                                              <span className={style.EventValue}>{user.Experience} Years</span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className={style.MemberCardActions} onClick={(e) => e.stopPropagation()}>
                                        {(user.connection_status === "accepted" || user.already_mentor === true) ? (
                                          <>
                                            {isMentor && !["organization admin", "org admin"].includes(String(user.role || user.Role || "").toLowerCase()) && (
                                              <button
                                                className={style.MessageButton}
                                                onClick={(e) => {
                                                  navigate("/user/learning", {
                                                    state: {
                                                      userID: user._id,
                                                      username: user.Username || user.username,
                                                      peerRole: user.role || user.Role,
                                                    },
                                                  });
                                                }}
                                              >
                                                Learnings
                                              </button>
                                            )}
                                            <button className={style.IconButton} onClick={(e) => { e.stopPropagation(); setPopup(true); setRecever(user.Username || user.username); setReceverID(user._id); roomCreate(user.Username || user.username, user._id); setChatLoader(true); }} title="Message"><BsChatDots /></button>
                                          </>
                                        ) : (
                                          <>
                                            <button
                                              className={`${style.ConnectButton} ${(buttonState[user._id]) || isConnectionRequestSent(user) ? style.ConnectButtonRequested : ''}`}
                                              disabled={(buttonState[user._id]) || isConnectionRequestSent(user)}
                                              onClick={(e) => { e.stopPropagation(); requestSend(user._id, user.Username || user.username); }}
                                            >
                                              {(buttonState[user._id]) || isConnectionRequestSent(user) ? (
                                                <>
                                                  <IoTimeOutline className={style.ConnectButtonIcon} />
                                                  {((user.connection_status || "").toLowerCase() === "accepted") ? "Connected" : "Pending"}
                                                </>
                                              ) : (
                                                <>
                                                  <BsPersonPlus className={style.ConnectButtonIcon} /> 
                                                  Connect
                                                </>
                                              )}
                                            </button>
                                            {isMentor && !["organization admin", "org admin"].includes(String(user.role || user.Role || "").toLowerCase()) && (
                                              <button
                                                className={style.MessageButton}
                                                onClick={() => {
                                                  navigate("/user/learning", {
                                                    state: {
                                                      userID: user._id,
                                                      username: user.Username || user.username,
                                                      peerRole: user.role || user.Role,
                                                    },
                                                  });
                                                }}
                                              >
                                                Learnings
                                              </button>
                                            )}
                                            <button className={style.IconButton} onClick={(e) => { e.stopPropagation(); setPopup(true); setRecever(user.Username || user.username); setReceverID(user._id); roomCreate(user.Username || user.username, user._id); setChatLoader(true); }} title="Message"><BsChatDots /></button>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                                {membersTotalPages <= 1 && filteredMembersTab.length > MEMBERS_SECTION_LIMIT && (
                                <div className={style.SeeMoreContainer}>
                                  <button className={style.SeeMoreButton} onClick={() => setSectionExpanded(prev => ({ ...prev, membersTab: !prev.membersTab }))}>
                                      {sectionExpanded.membersTab ? "See less" : `See more (${hiddenMembersCountTab} more)`}
                                  </button>
                                </div>
                              )}
                            </>
                          );
                        })() : <div>
                          {!lodaing ?
                            <p> "Oops ! There are many learners and mentors who wants to connect with you. You have not found them yet? Search and request for new connections."</p>
                            : ''}
                        </div>}
                      </div>
                    </div>
                  )}

                  {/* My Connections Container - uses /user/connection/list API, same UI as Club Network */}
                  {activeFilter === "Connections" && (
                    <div className={style.MainCard}>
                      <div className={style.MainCardHeader}>
                        <div className={style.MainCardHeaderColumn}>
                          <div className={style.SearchRow}>
                            {typeof onMenuToggle === "function" && !sidebarOpen && (
                              <button
                                type="button"
                                className={style.mobileHeaderMenuBtn}
                                onClick={onMenuToggle}
                                aria-label="Open menu"
                              >
                                <MdMoreVert size={20} />
                              </button>
                            )}
                            <div className={style.SectionSearchBar}>
                              <AiOutlineSearch className={style.SearchIcon} />
                              <input
                                className={style.SearchInput}
                                type="text"
                                placeholder="Search connections..."
                                autoComplete="off"
                                value={connectionSearchTerm}
                                onChange={(e) => setConnectionSearchTerm(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className={style.SectionHeaderRow}>
                            <span className={style.RequestLink} onClick={() => navigate("/requests")}>
                              <IoMailUnreadOutline /> Requests
                              {requestCount > 0 && <span className={style.RequestCountBadge}>{requestCount}</span>}
                              {sentRequestCount > 0 && (
                                <span className={style.SentRequestCountBadge} title="Pending requests you sent">
                                  {sentRequestCount}
                                </span>
                              )}
                              <IoChevronForward className={style.RequestArrow} />
                            </span>
                          </div>
                          <div className={style.CardFilterTabsWrapper}>
                            <button type="button" className={style.FilterScrollIndicator} aria-label="Scroll left" onClick={() => scrollFilterTabs(-1)}>
                              <IoChevronBack />
                            </button>
                            <div ref={filterTabsRef} className={style.CardFilterTabs}>
                            <button className={`${style.FilterTab} ${style.tabClubNetwork} ${activeFilter === "All" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("All"); setActiveMemberSubMenu("All"); setSearchText(""); }}>Club Network</button>
                            <button className={`${style.FilterTab} ${style.tabClubMembers} ${activeFilter === "Members" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Members"); setActiveMemberSubMenu("Members"); }}>Club Members</button>
                            <button className={`${style.FilterTab} ${style.tabMyConnections} ${activeFilter === "Connections" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Connections"); setActiveMemberSubMenu("Connections"); setSearchText(""); }}>My Connections</button>
                            <button className={`${style.FilterTab} ${activeFilter === "Opportunities" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Opportunities"); setActiveMemberSubMenu("Opportunities"); }}>New Opportunities</button>
                            <button className={`${style.FilterTab} ${activeFilter === "Events" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Events"); setActiveMemberSubMenu("Events"); }}>Upcoming Events</button>
                            <button className={`${style.FilterTab} ${activeFilter === "Referrals" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Referrals"); setActiveMemberSubMenu("Referrals"); }}>Referrals</button>
                          </div>
                            <button type="button" className={style.FilterScrollIndicator} aria-label="Scroll right" onClick={() => scrollFilterTabs(1)}>
                              <IoChevronForward />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className={style.FirstDiv}>
                        {connectionsLoading && !lodaing ? (
                          <Loader />
                        ) : connectionsList && connectionsList.length > 0 ? (
                          <>
                            {(sectionExpanded.connectionsTab ? connectionsList : connectionsList.slice(0, SECTION_LIMIT)).map((conn, index) => (
                              <div
                                key={index}
                                className={style.MemberCard}
                                onClick={() => handleUserClick(conn.user_id, "")}
                                style={{ cursor: "pointer" }}
                              >
                                <div className={style.MemberCardContent}>
                                  <div className={style.MemberCardHeader}>
                                    <div className={style.MemberCardAvatar}>
                                      <img src={getProfileSrc(conn.profile_image || conn.profile)} alt={conn.username} onError={handleProfileImageError} />
                                    </div>
                                    <div className={style.MemberCardInfo}>
                                      <div className={style.EventTitle}>
                                        {conn.username}
                                      </div>
                                    </div>
                                    <div className={style.MemberCardActions} onClick={(e) => e.stopPropagation()}>
                                      <button className={style.MessageButton} onClick={(e) => { e.stopPropagation(); setPopup(true); setRecever(conn.username); setReceverID(conn.user_id); roomCreate(conn.username, conn.user_id); setChatLoader(true); }}>Message</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                            {connectionsList.length > SECTION_LIMIT && (
                              <div className={style.SeeMoreContainer}>
                                <button className={style.SeeMoreButton} onClick={() => setSectionExpanded(prev => ({ ...prev, connectionsTab: !prev.connectionsTab }))}>
                                  {sectionExpanded.connectionsTab ? "See less" : `See more (${connectionsList.length - SECTION_LIMIT} more)`}
                                </button>
                              </div>
                            )}
                          </>
                        ) : (
                          <div className={style.NoEventsMessage}>
                            <p>No connections yet. Connect with members to build your network.</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Events Container - search bar + filters only when this tab is selected */}
                  {activeFilter === "Events" && (
                    <div className={style.MainCard}>
                      <div className={style.MainCardHeader}>
                        <div className={style.MainCardHeaderColumn}>
                          <div className={style.SearchRow}>
                            {typeof onMenuToggle === "function" && !sidebarOpen && (
                              <button
                                type="button"
                                className={style.mobileHeaderMenuBtn}
                                onClick={onMenuToggle}
                                aria-label="Open menu"
                              >
                                <MdMoreVert size={20} />
                              </button>
                            )}
                            <div className={style.SectionSearchBar}>
                              <AiOutlineSearch className={style.SearchIcon} />
                              <input
                                className={style.SearchInput}
                                type="text"
                                placeholder="Search events..."
                                autoComplete="off"
                                value={eventSearchTerm}
                                onChange={(e) => setEventSearchTerm(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className={style.CardFilterTabsWrapper}>
                            <button type="button" className={style.FilterScrollIndicator} aria-label="Scroll left" onClick={() => scrollFilterTabs(-1)}>
                              <IoChevronBack />
                            </button>
                            <div ref={filterTabsRef} className={style.CardFilterTabs}>
                            <button className={`${style.FilterTab} ${style.tabClubNetwork} ${activeFilter === "All" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("All"); setActiveMemberSubMenu("All"); setSearchText(""); }}>Club Network</button>
                            <button className={`${style.FilterTab} ${style.tabClubMembers} ${activeFilter === "Members" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Members"); setActiveMemberSubMenu("Members"); }}>Club Members</button>
                            <button className={`${style.FilterTab} ${style.tabMyConnections} ${activeFilter === "Connections" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Connections"); setActiveMemberSubMenu("Connections"); setSearchText(""); }}>My Connections</button>
                            <button className={`${style.FilterTab} ${activeFilter === "Opportunities" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Opportunities"); setActiveMemberSubMenu("Opportunities"); }}>New Opportunities</button>
                            <button className={`${style.FilterTab} ${activeFilter === "Events" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Events"); setActiveMemberSubMenu("Events"); }}>Upcoming Events</button>
                            <button className={`${style.FilterTab} ${activeFilter === "Referrals" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Referrals"); setActiveMemberSubMenu("Referrals"); }}>Referrals</button>
                          </div>
                            <button type="button" className={style.FilterScrollIndicator} aria-label="Scroll right" onClick={() => scrollFilterTabs(1)}>
                              <IoChevronForward />
                            </button>
                          </div>
                        </div>
                        {/* <div className={style.InviteButtonContainer}>
                          <button className={style.InviteMemberButton} onClick={() => { setInvite(true); inviteGenerate(); }}>
                            <AiOutlinePlus /> Invite
                          </button>
                        </div> */}
                      </div>
                      <div className={style.FirstDiv}>
                        {eventsLoading && !lodaing ? (
                          <Loader />
                        ) : events && events.length > 0 ? (
                          (() => {
                            const filteredEventsTab = events.filter(event => {
                              if (!eventSearchTerm.trim()) return true;
                              const searchLower = eventSearchTerm.toLowerCase();
                              return (
                                (event.event_title || event.title || "").toLowerCase().includes(searchLower) ||
                                (event.host_name || "").toLowerCase().includes(searchLower) ||
                                (event.event_mode || "").toLowerCase().includes(searchLower)
                              );
                            });
                            if (!filteredEventsTab.length) {
                              return (
                                <div className={style.NoEventsMessage}>
                                  <p>No events found</p>
                                </div>
                              );
                            }
                            const totalEventPagesTab = Math.max(1, Math.ceil(filteredEventsTab.length / EVENTS_PAGE_SIZE));
                            const currentEventPageTab = Math.min(eventsTabPage, totalEventPagesTab);
                            const startEventIndexTab = (currentEventPageTab - 1) * EVENTS_PAGE_SIZE;
                            const displayEventsTab = filteredEventsTab.slice(startEventIndexTab, startEventIndexTab + EVENTS_PAGE_SIZE);
                            return (
                              <>
                                {displayEventsTab.map((event, index) => (
                                  <div
                                    key={index}
                                    className={style.EventCard}
                                    onClick={() => {
                                      localStorage.setItem("eventId", event.event_id);
                                      localStorage.setItem("eventName", event.event_title || event.title || "Untitled Event");
                                      navigate("/event/details");
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <div className={style.EventCardContent}>
                                      <div className={style.EventTitle}>
                                        {event.event_title || event.title || "Untitled Event"}
                                      </div>
                                      <div className={style.EventDetails}>
                                        {event.host_name && (
                                          <div className={style.EventDetailItem}>
                                            <span className={style.EventLabel}>Host:</span>
                                            <span className={style.EventValue}>{event.host_name}</span>
                                          </div>
                                        )}
                                        {event.event_mode && (
                                          <div className={style.EventDetailItem}>
                                            <span className={style.EventLabel}>Mode:</span>
                                            <span className={style.EventValue}>{event.event_mode}</span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ))}
                                {totalEventPagesTab > 1 && (
                                  <div className={style.PaginationCenter} style={{ borderBottom: "none", marginBottom: 0 }}>
                                    <button
                                      type="button"
                                      className={style.MoreRecordsBtn}
                                      disabled={currentEventPageTab <= 1}
                                      onClick={() => setEventsTabPage((p) => Math.max(1, p - 1))}
                                    >
                                      Prev
                                    </button>
                                    <div className={style.PageNumbers} aria-label={`Pagination, page ${currentEventPageTab} of ${totalEventPagesTab}`}>
                                      {getPageItems(currentEventPageTab, totalEventPagesTab).map((it, idx) => (
                                        typeof it === "string" ? (
                                          <span key={`ev-tab-ellipsis-${idx}`} className={style.PageEllipsis}>...</span>
                                        ) : (
                                          <button
                                            key={`ev-tab-page-${it}`}
                                            type="button"
                                            className={`${style.PageBadge} ${Number(it) === Number(currentEventPageTab) ? style.PageBadgeActive : ""}`}
                                            onClick={() => setEventsTabPage(Number(it))}
                                          >
                                            {it}
                                          </button>
                                        )
                                      ))}
                                    </div>
                                    <button
                                      type="button"
                                      className={style.MoreRecordsBtn}
                                      disabled={currentEventPageTab >= totalEventPagesTab}
                                      onClick={() => setEventsTabPage((p) => Math.min(totalEventPagesTab, p + 1))}
                                    >
                                      Next
                                    </button>
                                  </div>
                                )}
                              </>
                            );
                          })()
                        ) : (
                          <div className={style.NoEventsMessage}>
                            <p>No events found</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Opportunities Container - search bar + filters only when this tab is selected */}
                  {activeFilter === "Opportunities" && (
                    <div className={style.MainCard}>
                      <div className={style.MainCardHeader}>
                        <div className={style.MainCardHeaderColumn}>
                          <div className={style.SearchRow}>
                            {typeof onMenuToggle === "function" && !sidebarOpen && (
                              <button
                                type="button"
                                className={style.mobileHeaderMenuBtn}
                                onClick={onMenuToggle}
                                aria-label="Open menu"
                              >
                                <MdMoreVert size={20} />
                              </button>
                            )}
                            <div className={style.SectionSearchBar}>
                              <AiOutlineSearch className={style.SearchIcon} />
                              <input
                                className={style.SearchInput}
                                type="text"
                                placeholder="Search opportunities..."
                                autoComplete="off"
                                value={opportunitySearchTerm}
                                onChange={(e) => setOpportunitySearchTerm(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className={style.CardFilterTabsWrapper}>
                            <button type="button" className={style.FilterScrollIndicator} aria-label="Scroll left" onClick={() => scrollFilterTabs(-1)}>
                              <IoChevronBack />
                            </button>
                            <div ref={filterTabsRef} className={style.CardFilterTabs}>
                            <button className={`${style.FilterTab} ${style.tabClubNetwork} ${activeFilter === "All" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("All"); setActiveMemberSubMenu("All"); setSearchText(""); }}>Club Network</button>
                            <button className={`${style.FilterTab} ${style.tabClubMembers} ${activeFilter === "Members" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Members"); setActiveMemberSubMenu("Members"); }}>Club Members</button>
                            <button className={`${style.FilterTab} ${style.tabMyConnections} ${activeFilter === "Connections" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Connections"); setActiveMemberSubMenu("Connections"); setSearchText(""); }}>My Connections</button>
                            <button className={`${style.FilterTab} ${activeFilter === "Opportunities" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Opportunities"); setActiveMemberSubMenu("Opportunities"); }}>New Opportunities</button>
                            <button className={`${style.FilterTab} ${activeFilter === "Events" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Events"); setActiveMemberSubMenu("Events"); }}>Upcoming Events</button>
                            <button className={`${style.FilterTab} ${activeFilter === "Referrals" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Referrals"); setActiveMemberSubMenu("Referrals"); }}>Referrals</button>
                          </div>
                            <button type="button" className={style.FilterScrollIndicator} aria-label="Scroll right" onClick={() => scrollFilterTabs(1)}>
                              <IoChevronForward />
                            </button>
                          </div>
                        </div>
                        {/* <div className={style.InviteButtonContainer}>
                          <button className={style.InviteMemberButton} onClick={() => { setInvite(true); inviteGenerate(); }}>
                            <AiOutlinePlus /> Invite
                          </button>
                        </div> */}
                      </div>
                      <div className={style.OpportunitiesContainer}>
                        {opportunitiesLoading && !lodaing ? (
                          <Loader />
                        ) : opportunities && opportunities.length > 0 ? (
                          (() => {
                            const filteredOpportunitiesTab = opportunities.filter(opportunity => {
                              if (!opportunitySearchTerm.trim()) return true;
                              const searchLower = opportunitySearchTerm.toLowerCase();
                              return (
                                (opportunity.job_title || opportunity.name || "").toLowerCase().includes(searchLower) ||
                                (opportunity.designation || "").toLowerCase().includes(searchLower) ||
                                (opportunity.job_description || opportunity.description || "").toLowerCase().includes(searchLower)
                              );
                            });
                            if (!filteredOpportunitiesTab.length) {
                              return (
                                <div className={style.NoEventsMessage}>
                                  <p>No results found</p>
                                </div>
                              );
                            }
                            const totalOpportunityPagesTab = Math.max(1, Math.ceil(filteredOpportunitiesTab.length / OPPORTUNITIES_PAGE_SIZE));
                            const currentOpportunityPageTab = Math.min(opportunitiesTabPage, totalOpportunityPagesTab);
                            const startIndexTab = (currentOpportunityPageTab - 1) * OPPORTUNITIES_PAGE_SIZE;
                            const pageOpportunitiesTab = filteredOpportunitiesTab.slice(startIndexTab, startIndexTab + OPPORTUNITIES_PAGE_SIZE);
                            const displayOpportunitiesTab = pageOpportunitiesTab.slice(0, opportunitiesTabVisibleInPage);
                            return (
                              <div className={style.OpportunitiesList}>
                                {totalOpportunityPagesTab > 1 && (
                                  <div className={style.PaginationCenter}>
                                    <button
                                      type="button"
                                      className={style.MoreRecordsBtn}
                                      disabled={currentOpportunityPageTab <= 1}
                                      onClick={() => setOpportunitiesTabPage((p) => Math.max(1, p - 1))}
                                    >
                                      Previous
                                    </button>
                                    <div className={style.PageNumbers} aria-label={`Pagination, page ${currentOpportunityPageTab} of ${totalOpportunityPagesTab}`}>
                                      {getPageItems(currentOpportunityPageTab, totalOpportunityPagesTab).map((it, idx) => (
                                        typeof it === "string" ? (
                                          <span key={`op-tab-ellipsis-${idx}`} className={style.PageEllipsis}>...</span>
                                        ) : (
                                          <button
                                            key={`op-tab-page-${it}`}
                                            type="button"
                                            className={`${style.PageBadge} ${Number(it) === Number(currentOpportunityPageTab) ? style.PageBadgeActive : ""}`}
                                            onClick={() => setOpportunitiesTabPage(Number(it))}
                                          >
                                            {it}
                                          </button>
                                        )
                                      ))}
                                    </div>
                                    <button
                                      type="button"
                                      className={style.MoreRecordsBtn}
                                      disabled={currentOpportunityPageTab >= totalOpportunityPagesTab}
                                      onClick={() => setOpportunitiesTabPage((p) => Math.min(totalOpportunityPagesTab, p + 1))}
                                    >
                                      Next
                                    </button>
                                  </div>
                                )}
                                {displayOpportunitiesTab.map((opportunity, index) => (
                                  <div
                                    key={index}
                                    className={style.OpportunityCard}
                                    onClick={() => navigate(`/job-view/${opportunity.id || opportunity._id || opportunity.vacancy_id}`)}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <div className={style.OpportunityContent}>
                                      <div className={style.OpportunityMain}>
                                        <h3 className={style.OpportunityTitle}>
                                          {opportunity.job_title || opportunity.name || "-"} / {opportunity.designation}
                                        </h3>
                                        <p className={style.OpportunityDescription}>
                                          {opportunity.job_description || opportunity.description || "-"}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                                {(displayOpportunitiesTab.length < pageOpportunitiesTab.length || opportunitiesTabVisibleInPage > SECTION_LIMIT) && (
                                  <div className={style.SeeMoreContainer}>
                                    <button
                                      type="button"
                                      className={style.SeeMoreButton}
                                      onClick={() => {
                                        if (displayOpportunitiesTab.length < pageOpportunitiesTab.length) {
                                          setOpportunitiesTabVisibleInPage((c) =>
                                            Math.min(c + 5, pageOpportunitiesTab.length)
                                          );
                                        } else {
                                          setOpportunitiesTabVisibleInPage(SECTION_LIMIT);
                                        }
                                      }}
                                    >
                                      {displayOpportunitiesTab.length < pageOpportunitiesTab.length ? "Show more" : "Show less"}
                                    </button>
                                  </div>
                                )}
                              </div>
                            );
                          })()
                        ) : (
                          <div>
                            <p>No opportunities found</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Referrals Container - same structure as other tabs */}
                  {activeFilter === "Referrals" && (
                    <div className={style.MainCard}>
                      <div className={style.MainCardHeader}>
                        <div className={style.MainCardHeaderColumn}>
                          <div className={style.ReferralSearchRow}>
                            <div className={style.SearchRow}>
                              {typeof onMenuToggle === "function" && !sidebarOpen && (
                                <button
                                  type="button"
                                  className={style.mobileHeaderMenuBtn}
                                  onClick={onMenuToggle}
                                  aria-label="Open menu"
                                >
                                  <MdMoreVert size={20} />
                                </button>
                              )}
                              <div className={style.SectionSearchBar}>
                                <AiOutlineSearch className={style.SearchIcon} />
                                <input
                                  className={style.SearchInput}
                                  type="text"
                                  placeholder="Search referrals..."
                                  autoComplete="off"
                                  value={referralSearchTerm}
                                  onChange={(e) => setReferralSearchTerm(e.target.value)}
                                />
                              </div>
                            </div>
                            <div className={style.ReferralHeaderSwitch}>
                              <span className={style.ReferralLabel}>Received</span>
                              <Switch
                                onChange={(checked) => setReferralSubTab(checked ? "Given" : "Received")}
                                checked={referralSubTab === "Given"}
                                offColor="#0151CD"
                                onColor="#0151CD"
                                checkedIcon={false}
                                uncheckedIcon={false}
                                height={24}
                                width={48}
                              />
                              <span className={style.ReferralLabel}>Given</span>
                            </div>
                          </div>
                          <div className={style.CardFilterTabsWrapper}>
                            <button type="button" className={style.FilterScrollIndicator} aria-label="Scroll left" onClick={() => scrollFilterTabs(-1)}>
                              <IoChevronBack />
                            </button>
                            <div ref={filterTabsRef} className={style.CardFilterTabs}>
                            <button className={`${style.FilterTab} ${style.tabClubNetwork} ${activeFilter === "All" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("All"); setActiveMemberSubMenu("All"); setSearchText(""); }}>Club Network</button>
                            <button className={`${style.FilterTab} ${style.tabClubMembers} ${activeFilter === "Members" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Members"); setActiveMemberSubMenu("Members"); }}>Club Members</button>
                            <button className={`${style.FilterTab} ${style.tabMyConnections} ${activeFilter === "Connections" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Connections"); setActiveMemberSubMenu("Connections"); setSearchText(""); }}>My Connections</button>
                            <button className={`${style.FilterTab} ${activeFilter === "Opportunities" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Opportunities"); setActiveMemberSubMenu("Opportunities"); }}>New Opportunities</button>
                            <button className={`${style.FilterTab} ${activeFilter === "Events" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Events"); setActiveMemberSubMenu("Events"); }}>Upcoming Events</button>
                            <button className={`${style.FilterTab} ${activeFilter === "Referrals" ? style.ActiveFilterTab : ""}`} onClick={() => { setActiveFilter("Referrals"); setActiveMemberSubMenu("Referrals"); }}>Referrals</button>
                          </div>
                            <button type="button" className={style.FilterScrollIndicator} aria-label="Scroll right" onClick={() => scrollFilterTabs(1)}>
                              <IoChevronForward />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className={style.FirstDiv}>
                        {referralLoading ? (
                          <Loader />
                        ) : (
                          (() => {
                            const currentList = referralSubTab === "Received" ? receivedReferrals : givenReferrals;
                            if (!currentList.length) {
                              return (
                                <div className={style.NoEventsMessage}>
                                  <p>{referralSubTab === "Received" ? "No received referrals found." : "No given referrals found."}</p>
                                </div>
                              );
                            }
                            return currentList.map((user, index) => (
                              <div
                                key={`${user.user_id || "ref-tab"}-${index}`}
                                className={style.MemberCard}
                                onClick={() => user.user_id && handleUserClick(user.user_id, user.role)}
                                style={{ cursor: user.user_id ? "pointer" : "default" }}
                              >
                                <div className={style.MemberCardContent}>
                                  <div className={style.MemberCardHeader}>
                                    <div className={style.MemberCardAvatar}>
                                      <img src={getProfileSrc(user.profile)} alt={user.username || "Referral user"} onError={handleProfileImageError} />
                                    </div>
                                    <div className={style.MemberCardInfo}>
                                      <div className={style.EventTitle}>
                                        {user.username
                                          ? `${user.username}${user.email ? ` (${user.email})` : ""}`
                                          : (user.email || "Unknown User")}
                                        {user.role ? <> <span className={style.RoleBadge}>{user.role}</span></> : ""}
                                      </div>
                                      <div className={style.EventDetails}>
                                        {!user.username && user.email && (
                                          <div className={style.EventDetailItem}>
                                            <span className={style.EventLabel}>Email:</span>
                                            <span className={style.EventValue}>{user.email}</span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ));
                          })()
                        )}
                      </div>
                    </div>
                  )}
                </>

                :
                <div className={style.SearchDiv}>
                  {(() => {
                    // Detect if search term matches a filter name (exact or starts with)
                    const searchLower = searchText?.toLowerCase().trim() || "";
                    const isSearchingOpportunities = searchLower === "opportunities" || searchLower === "opportunity" || searchLower.startsWith("opportunit");
                    const isSearchingEvents = searchLower === "events" || searchLower === "event" || searchLower.startsWith("event");
                    const isSearchingMembers = searchLower === "members" || searchLower === "member" || searchLower.startsWith("member");

                    // Determine which sections to show based on search term or active filter
                    let showMembers = false;
                    let showOpportunities = false;
                    let showEvents = false;

                    // Priority: if search matches a filter name exactly, show only that section
                    if (isSearchingOpportunities) {
                      showOpportunities = true;
                      showMembers = false;
                      showEvents = false;
                    } else if (isSearchingEvents) {
                      showEvents = true;
                      showMembers = false;
                      showOpportunities = false;
                    } else if (isSearchingMembers) {
                      showMembers = true;
                      showOpportunities = false;
                      showEvents = false;
                    } else {
                      // If search doesn't match filter names, respect activeFilter
                      showMembers = activeFilter === "All" || activeFilter === "Members";
                      showOpportunities = activeFilter === "All" || activeFilter === "Opportunities";
                      showEvents = activeFilter === "All" || activeFilter === "Events";
                    }

                    const filteredMembersSearch = showMembers
                      ? (searcheditem || []).filter(search => {
                        if (!memberSearchTerm.trim()) return true;
                        const searchLower = memberSearchTerm.toLowerCase();
                        return (
                          (search.Username || "").toLowerCase().includes(searchLower) ||
                          (search.Email || search.email || "").toLowerCase().includes(searchLower) ||
                          (search.Role || "").toLowerCase().includes(searchLower) ||
                          (search.About || "").toLowerCase().includes(searchLower)
                        );
                      })
                      : [];

                    const filteredOpportunitiesSearch = showOpportunities
                      ? (opportunities || []).filter(opportunity => {
                        if (!opportunitySearchTerm.trim()) return true;
                        const searchLower = opportunitySearchTerm.toLowerCase();
                        return (
                          (opportunity.job_title || opportunity.name || "").toLowerCase().includes(searchLower) ||
                          (opportunity.designation || "").toLowerCase().includes(searchLower) ||
                          (opportunity.job_description || opportunity.description || "").toLowerCase().includes(searchLower)
                        );
                      })
                      : [];

                    const filteredEventsSearch = showEvents
                      ? (events || []).filter(event => {
                        if (!eventSearchTerm.trim()) return true;
                        const searchLower = eventSearchTerm.toLowerCase();
                        return (
                          (event.event_title || event.title || "").toLowerCase().includes(searchLower) ||
                          (event.host_name || "").toLowerCase().includes(searchLower) ||
                          (event.event_mode || "").toLowerCase().includes(searchLower)
                        );
                      })
                      : [];

                    const hasAnySearchResult =
                      (showMembers && filteredMembersSearch.length > 0) ||
                      (showOpportunities && filteredOpportunitiesSearch.length > 0) ||
                      (showEvents && filteredEventsSearch.length > 0);

                    return (
                      <>
                        {/* Show Members search results */}
                        {showMembers && filteredMembersSearch.length > 0 && (
                          <div className={style.MainCard}>
                            <div className={style.MainCardHeader}>
                              <div className={style.SectionSearchBar}>
                                <AiOutlineSearch className={style.SearchIcon} />
                                <input
                                  className={style.SearchInput}
                                  type="text"
                                  placeholder="Search members..."
                                  autoComplete="off"
                                  value={memberSearchTerm}
                                  onChange={(e) => setMemberSearchTerm(e.target.value)}
                                />
                              </div>
                            </div>
                            <div className={style.FirstDiv}>
                              {filteredMembersSearch.map((search, index) => {
                                return (
                                  <div key={index} className={style.FirstCard}>
                                    <div className={style.Image}>
                                      <div className={style.imageDiv}> <img src={ProfileImage} alt={search.Username} onError={handleProfileImageError} />  </div>
                                    </div>
                                    <div className={style.Content}>
                                      <div className={style.CardHeader} onClick={() => handleUserClick(search._id, search.Role)}>
                                        <div className={style.NameRow}>
                                          <h3 className={style.UserName}>{search.Username}{search.Role ? <> <span className={style.RoleBadge}>{getRoleLabel(search.Role)}</span></> : ''}</h3>
                                        </div>
                                        {search.About && (
                                          <p className={style.Bio}>{search.About}</p>
                                        )}
                                        {search.Experience && (
                                          <p className={style.Location}>{search.Experience} Years of Experience</p>
                                        )}
                                      </div>
                                      {search.already_mentor === true || search.connection_status === "accepted" ? '' :
                                        <div className={style.ActionButtons}>
                                          <button
                                            className={`${style.InviteButton} ${(buttonState[search._id]) || isConnectionRequestSent(search) ? style.RequestedButton : ''}`}
                                            disabled={(buttonState[search._id]) || isConnectionRequestSent(search)}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              requestSend(search._id, search.Username)
                                            }}
                                          >
                                            {(buttonState[search._id]) || isConnectionRequestSent(search) ? "Requested" : "Send Request"}
                                          </button>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        )}

                        {/* Show Opportunities search results */}
                        {showOpportunities && (
                          <div className={style.MainCard}>
                            <div className={style.MainCardHeader}>
                              <h2 className={style.MembersHeadline}>New Opportunities</h2>
                              <div className={style.SectionSearchBar}>
                                <AiOutlineSearch className={style.SearchIcon} />
                                <input
                                  className={style.SearchInput}
                                  type="text"
                                  placeholder="Search opportunities..."
                                  autoComplete="off"
                                  value={opportunitySearchTerm}
                                  onChange={(e) => setOpportunitySearchTerm(e.target.value)}
                                />
                              </div>
                            </div>
                            <div className={style.OpportunitiesContainer}>
                              {opportunitiesLoading && !lodaing ? (
                                <Loader />
                              ) : opportunities && opportunities.length > 0 ? (
                                (() => {
                                  return filteredOpportunitiesSearch.length > 0 ? (
                                    <div className={style.OpportunitiesList}>
                                      {filteredOpportunitiesSearch.map((opportunity, index) => (
                                        <div
                                          key={index}
                                          className={style.OpportunityCard}
                                          onClick={() => navigate(`/job-view/${opportunity.id || opportunity._id || opportunity.vacancy_id}`)}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <div className={style.OpportunityContent}>
                                            <div className={style.OpportunityMain}>
                                              <h3 className={style.OpportunityTitle}>
                                                {opportunity.job_title || opportunity.name || "-"} / {opportunity.designation}
                                              </h3>
                                              <p className={style.OpportunityDescription}>
                                                {opportunity.job_description || opportunity.description || "-"}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                      <div className={style.ViewAllContainer}>
                                        <button
                                          className={style.ViewAllButton}
                                          onClick={() => {
                                            setActiveFilter("Opportunities");
                                            setActiveMemberSubMenu("Opportunities");
                                          }}
                                        >
                                          Show More Opportunities
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <div>
                                      <p>No opportunities found</p>
                                    </div>
                                  );
                                })()
                              ) : (
                                <div>
                                  <p>No opportunities found</p>
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Show Events search results */}
                        {showEvents && (
                          <div className={style.MainCard}>
                            <div className={style.MainCardHeader}>
                              <h2 className={style.MembersHeadline}>Upcoming Events</h2>
                              <div className={style.SectionSearchBar}>
                                <AiOutlineSearch className={style.SearchIcon} />
                                <input
                                  className={style.SearchInput}
                                  type="text"
                                  placeholder="Search events..."
                                  autoComplete="off"
                                  value={eventSearchTerm}
                                  onChange={(e) => setEventSearchTerm(e.target.value)}
                                />
                              </div>
                            </div>
                            <div className={style.FirstDiv}>
                              {eventsLoading && !lodaing ? (
                                <Loader />
                              ) : events && events.length > 0 ? (
                                (() => {
                                  return filteredEventsSearch.length > 0 ? (
                                    filteredEventsSearch.map((event, index) => (
                                      <div
                                        key={index}
                                        className={style.EventCard}
                                        onClick={() => {
                                          localStorage.setItem("eventId", event.event_id);
                                          localStorage.setItem("eventName", event.event_title || event.title || "Untitled Event");
                                          navigate("/event/details");
                                        }}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <div className={style.EventCardContent}>
                                          <div className={style.EventTitle}>
                                            {event.event_title || event.title || "Untitled Event"}
                                          </div>
                                          <div className={style.EventDetails}>
                                            {event.host_name && (
                                              <div className={style.EventDetailItem}>
                                                <span className={style.EventLabel}>Host:</span>
                                                <span className={style.EventValue}>{event.host_name}</span>
                                              </div>
                                            )}
                                            {event.event_mode && (
                                              <div className={style.EventDetailItem}>
                                                <span className={style.EventLabel}>Mode:</span>
                                                <span className={style.EventValue}>{event.event_mode}</span>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                  ) : (
                                    <div className={style.NoEventsMessage}>
                                      <p>No events found</p>
                                    </div>
                                  );
                                })()
                              ) : (
                                <div className={style.NoEventsMessage}>
                                  <p>No events found</p>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        {!hasAnySearchResult && !opportunitiesLoading && !eventsLoading && (
                          <div className={style.NoEventsMessage}>
                            <p>No results found</p>
                          </div>
                        )}
                      </>
                    );
                  })()}
                </div>}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Community

